webpackJsonp([1],{

/***/ "+EUx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),_c('Timer'),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm._f("translate")("Please Touch a Donation amount")))]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")]),_vm._v(" "),_c('div',{staticClass:"main-height"},[_c('div',{staticClass:"amount-select-section"},[_c('div',[_c('div',{staticClass:"donation-aniybt-details cursor",on:{"click":function($event){_vm.donateAmount(5)}}},[_c('img',{attrs:{"src":"static/images/5pounds.png"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"donation-aniybt-details cursor",on:{"click":function($event){_vm.donateAmount(10)}}},[_c('img',{attrs:{"src":"static/images/10pounds.png"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"donation-aniybt-details cursor",on:{"click":function($event){_vm.donateAmount(20)}}},[_c('img',{attrs:{"src":"static/images/20pounds.png"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"donation-aniybt-details cursor",on:{"click":function($event){_vm.donateAmount(50)}}},[_c('img',{attrs:{"src":"static/images/50pounds.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"other-donation-option"},[_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":function($event){_vm.redirectToChangeAmount()}}},[_vm._v(_vm._s(_vm._f("translate")("Other Amount")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.back}},[_vm._v(_vm._s(_vm._f("translate")("Back")))])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+IbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newAmount: null
    };
  },

  props: ['amount'],
  created: function created() {
    this.newAmount = this.amount;
  },
  methods: {
    amountChange: function amountChange() {
      if (this.newAmount.length) {
        this.newAmount = (this.newAmount + '').replace(/\D+/g, '') * 1;
        if (this.newAmount >= 5000) {
          this.newAmount = 5000;
          this.$emit('changedAmount', this.newAmount);
        } else {
          this.$emit('changedAmount', this.newAmount);
        }
      } else {
        this.$emit('changedAmount', null);
      }
    },
    checkAmount: function checkAmount() {
      // if (!this.newAmount) {
      //   this.newAmount = 1
      //   this.$emit('changedAmount', this.newAmount)
      // } else {
      // }
    }
  }
});

/***/ }),

/***/ "+hdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-domain-sec app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('Languages',{staticClass:"languages",attrs:{"settings":false}}),_vm._v(" "),_c('div',{staticClass:"left-sec"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/images/logo.png"}}),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_c('div',{staticClass:"welcome"},[_vm._v(_vm._s(_vm._f("translate")("WELCOME TO")))]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.user.data.name))])]),_vm._v(" "),_c('div',{staticClass:"navigation"},[_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.donationsScreen}},[_vm._v(_vm._s(_vm._f("translate")(_vm.donationsText)))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.reportsLoginForm}},[_vm._v(_vm._s(_vm._f("translate")(_vm.reportsText)))])])])])]),_vm._v(" "),_c('div',{staticClass:"mosque-image-sec"},[_c('div',{staticClass:"mosque-image"},[_c('div',{staticClass:"gradient-dark"}),_vm._v(" "),_c('div',{staticClass:"ful-visible-image",style:({ backgroundImage: 'url('+_vm.user.data.image+')'})}),_vm._v(" "),_c('div',{staticClass:"opacity-image",style:({ backgroundImage: 'url('+_vm.user.data.image+')'})}),_vm._v(" "),_vm._m(0)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"every-pound"},[_c('span',[_vm._v("Every")]),_vm._v(" "),_c('span',[_vm._v("Pound")]),_vm._v(" "),_c('span',[_vm._v("Matters")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "/Qcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['childOption'],
  computed: {},
  methods: {},
  components: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ "0PCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Languages__ = __webpack_require__("hJCX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DonationRequested',
  data: function data() {
    return {
      amount: null,
      donationName: null,
      tid: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'donationType', 'donationAmount', 'PSSaleRequestStatus', 'terminalNotificationStatus', 'PSSaleRequestResponse', 'declineSignatureRequiredTransaction'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'resetPSSaleRequestStatus', 'updateDonationRequest', 'declineSignatureVerification'])),
  components: {
    Languages: __WEBPACK_IMPORTED_MODULE_2__Languages__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.amount = this.donationAmount;
    this.donationName = this.donationType;
    this.tid = this.$route.params.terminalId;
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this.token) {
        _this.$router.push({ path: '/' + _this.tid + '/' });
      } else {
        _this.changeLoadingStatus(false);
      }
    });
  },
  watch: {
    terminalNotificationStatus: function terminalNotificationStatus(newValue) {
      console.log('terminalNotificationStatus' + newValue);
      this.transactionReason = newValue;
    },
    PSSaleRequestResponse: function PSSaleRequestResponse(newValue) {
      this.updateDonationRequest(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newValue));
    },
    PSSaleRequestStatus: function PSSaleRequestStatus(newValue) {
      this.$nextTick(this.resetPSSaleRequestStatus.bind(this));
      this.updateDonationRequest(this.PSSaleRequestResponse);
      if (newValue === true) {
        this.$router.push({ path: '/' + this.tid + '/thanks-giving/' + this.donationType + '/' + this.donationAmount + '/' + this.PSSaleRequestResponse.id });
      } else if (newValue === false) {
        this.changeLoadingStatus(false);
        var status = this.terminalNotificationStatus;
        if (status === 'TIMED_OUT') {
          this.$router.push({ path: '/' + this.tid + '/time-out/' + this.terminalNotificationStatus + '/' + this.donationType + '/' + this.donationAmount + '/' + this.PSSaleRequestResponse.id });
        } else {
          this.$router.push({ path: '/' + this.tid + '/payment-failed/' + this.terminalNotificationStatus + '/' + this.donationType + '/' + this.donationAmount + '/' + this.PSSaleRequestResponse.id });
        }
      }
    },
    declineSignatureRequiredTransaction: function declineSignatureRequiredTransaction(newValue) {
      if (newValue) {
        this.declineSignatureVerification({ socket: this.$socket });
      }
    }
  }
});

/***/ }),

/***/ "0z+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numpad-layour"},[_c('div',{staticClass:"keypad numbers"},_vm._l((_vm.numberKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return (_vm.editData !== 'username')?_c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}}):_vm._e()})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.qwertyKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.asdfKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.zxcKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad otherkeys"},_vm._l((_vm.otherKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1WYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keyboard_vue__ = __webpack_require__("VYnR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34845d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_vue__ = __webpack_require__("qJeT");
function injectStyle (ssrContext) {
  __webpack_require__("3G/z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34845d3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keyboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34845d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1wQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_numpad_vue__ = __webpack_require__("XsZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5294d8c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_numpad_vue__ = __webpack_require__("DQDj");
function injectStyle (ssrContext) {
  __webpack_require__("eNMX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5294d8c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_numpad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5294d8c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_numpad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2eF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numpad-layour"},[_c('div',{staticClass:"keypad numbers"},_vm._l((_vm.numberKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return (_vm.editData !== 'username')?_c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}}):_vm._e()})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.qwertyKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.asdfKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.zxcKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad otherkeys"},_vm._l((_vm.otherKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2hLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm._f("translate")("Please Touch a donation type")))]),_vm._v(" "),_c('div',{staticClass:"main-height"},[(!_vm.clickOther)?_c('div',{staticClass:"reports-section",attrs:{"items":_vm.user.data.donationCategories.length}},_vm._l((_vm.user.data.donationCategories),function(option){return _c('div',{key:option.id,staticClass:"masjid-fund main-donations"},[_vm._m(0,true),_vm._v(" "),_c('donationOption',{staticClass:"cursor",attrs:{"option":option},on:{"clickOption":_vm.setDonationType}})],1)})):_vm._e(),_vm._v(" "),(_vm.clickOther)?_c('div',{staticClass:"reports-section other-child-options-sec"},_vm._l((_vm.user.data.donationCategories),function(option){return (option.id === 4)?_c('div',{key:option.id,staticClass:"masjid-fund other-donations"},[_vm._l((option.childCategories),function(category){return _c('div',{key:category.id,staticClass:"child-options",on:{"click":function($event){_vm.setDonationType(category)}}},[_vm._m(1,true),_vm._v(" "),_c('childDonationOptions',{staticClass:"cursor",attrs:{"childOption":category}})],1)}),_vm._v(" "),_c('div',{staticClass:"child-options back-label cursor",on:{"click":_vm.backToMainDonations}},[_vm._v(_vm._s(_vm._f("translate")("Back")))])],2):_vm._e()})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")])],1)]),_vm._v(" "),_c('div',{staticClass:"full-screen reports-section other-reports-section",staticStyle:{"display":"none"}},[_c('div',{staticClass:"musallah"},[_c('div',{staticClass:"donation-details"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.musallah)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.musallah)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"madarasa"},[_c('div',{staticClass:"donation-details"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.madarasa)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.madarasa)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"iftiar"},[_c('div',{staticClass:"donation-details"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.iftiar)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.iftiar)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"imam-salary"},[_c('div',{staticClass:"donation-details"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.imamSalary)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.imamSalary)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"funeral"},[_c('div',{staticClass:"donation-details"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.funeral)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.funeral)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"flods"},[_c('div',{staticClass:"donation-details"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.flods)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.flods)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"earth-quicks"},[_c('div',{staticClass:"donation-details"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.earthQuicks)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.earthQuicks)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"construction"},[_c('div',{staticClass:"donation-details"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.construction)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.construction)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"sadqaEFitr"},[_c('div',{staticClass:"donation-details"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.sadqaEFitr)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.sadqaEFitr)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"masjidMembership"},[_c('div',{staticClass:"donation-details"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.masjidMembership)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.masjidMembership)}}},[_vm._v(" Continue ›")])])]),_vm._v(" "),_c('div',{staticClass:"fundsfOMasques"},[_c('div',{staticClass:"donation-details"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.fundsfOMasques)))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm._f("translate")(_vm.zakathDesc)))]),_vm._v(" "),_c('div',{staticClass:"continue",on:{"click":function($event){_vm.setDonationType(_vm.fundsfOMasques)}}},[_vm._v(" Continue ›")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glow"},[_c('img',{attrs:{"src":"/static/images/glow.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glow"},[_c('img',{attrs:{"src":"/static/images/glow.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/musallah.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/madarasa.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/iftiar.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/imam-salary.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/funeral.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/flods.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/earth-quicks.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/construction.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/other-donations.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/other-donations.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"static/images/other-donations.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2x9v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lan: null
    };
  },

  props: ['languages', 'language'],
  created: function created(e) {
    this.lan = this.language;
  },
  methods: {
    languageSet: function languageSet(l) {
      this.$emit('languageChange', l);
    }
  }
});

/***/ }),

/***/ "2yAW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAmount),expression:"newAmount"}],attrs:{"type":"number","step":"1","max":"5000"},domProps:{"value":(_vm.newAmount)},on:{"blur":_vm.checkAmount,"keyup":_vm.amountChange,"input":function($event){if($event.target.composing){ return; }_vm.newAmount=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "35nI":
/***/ (function(module, exports) {

module.exports = {"Mosque Fund":"મસ્જિદ ફંડ","Masjid Fund":"મસ્જિદ ફંડ","Sadaqah":"સદકાહ","Zakah":"ઝાકાહ","Other Donations":"અન્ય દાન","Other":"અન્ય","Sadqa-e-Fitr":"સદકા-એ-ફિતર","Funeral":"અંતિમવિધિ","Iftari":"ચેતવણી","Masjid Membership":"મસ્જિદ સભ્યપદ","Madarsah":"મદ્રાસા","Earthquake Appeal":"ભૂકંપ અપીલ","Flood Appeal":"પૂર અપીલ","Musallah":"મુસલહ","Construction":"બાંધકામ","Fund For Other Masjid":"અન્ય મસ્જિદ માટે ફંડ","Pay For Imam Salary":"ઇમામ પગાર માટે પે","Forgot Password?":"પાસવર્ડ ભૂલી ગયા છો?","Password":"પાસવર્ડ","PIN_ENTRY":"PIN દાખલ કરો","CONNECTING":"કનેક્ટિંગ","RETRYING":"ફરી પ્રયાસ કરી રહ્યું છે","APPROVED":"મંજૂર","PLEASE_WAIT":"મહેરબાની કરી રાહ જુવો","CONNECTION_MADE":"કનેક્શન કર્યું","PROCESSING_ERROR":"પ્રોસેસિંગ ભૂલ","CARD_ERROR":"કાર્ડ ભૂલ","REMOVE_CARD":"કાર્ડ દૂર કરો","SIGNATURE_VERIFICATION_PROCESS_COMPLETED":"હસ્તાક્ષર ચકાસણી પ્રક્રિયા પૂર્ણ","IDLE":"મહેરબાની કરી રાહ જુવો","INSERT CARD":"કાર્ડ શામેલ કરો","INSERT_CARD":"કાર્ડ શામેલ કરો","Donations page":"દાન પાનું","Thank you for choosing to donate for":"માટે દાન કરવાનું પસંદ કરવા બદલ આભાર","Please select the amount":"કૃપા કરીને રકમ પસંદ કરો","If you wish to donate a different amount, please enter it here":"જો તમે કોઈ અલગ રકમ દાન કરવા માંગો છો, તો તે અહીં દાખલ કરો","Continue":"ચાલુ રાખો","You are almost done. Please review and confirm":"તમે લગભગ પૂર્ણ થાય છે કૃપા કરીને સમીક્ષા કરો અને પુષ્ટિ કરો","Login":"લૉગિન","Logout":"લૉગ આઉટ","Enter valid details":"માન્ય વિગતો દાખલ કરો","Donations Page":"દાન પૃષ્ઠ","Reports":"અહેવાલો","Want to change donation":"દાન બદલવા માંગો છો","you":" તમે","for":"માટે","donating":"દાન","Donate Now":"હવે દાન કરો","Touch / Insert or Swipe your card":"તમારું કાર્ડ ટચ કરો / દાખલ કરો અથવા સ્વાઇપ કરો","Transaction has been":"ટ્રાન્ઝેક્શન થઈ ગયું છે","failed with status":"સ્થિતિ સાથે નિષ્ફળ","CANCELLED":"રદ થયેલ","Cancel":"રદ કરો","Retry":"ફરી પ્રયાસ કરો","Remaining Time":"બાકી સમય","Thank you for your support":"તમારા સહકાર બદલ આભાર","Do you want a receipt?":"શું તમે એક રસીદ માંગો છો?","Yes":"હા","No, thanks":"ના આભાર","Send":"મોકલો","You are donating":"તમે દાન કરી રહ્યાં છો","Transaction has been failed with status":"વ્યવહારો સ્થિતિ સાથે નિષ્ફળ રહ્યું છે","WELCOME TO":"સ્વાગત","EVERY":"દરેક","POUND":"POUND","MATTERS":"મેટર્સ","Please Touch a Currency amount":"કૃપા કરીને ચલણ રકમને ટચ કરો","Other Amount":"અન્ય રકમ","All Donations are Voluntary , T & C applies":"બધા દાન સ્વૈચ્છિક છે, ટી & સી લાગુ પડે છે","Enter your donation amount":"તમારી દાન રકમ દાખલ કરો","Donation details":"દાનની વિગતો","Confirm":"પુષ્ટિ કરો","Please review and confirm":"કૃપા કરીને સમીક્ષા કરો અને પુષ્ટિ કરો","Tap to pay":"ચૂકવણી કરવા માટે ટેપ કરો","No, Thanks":"ના આભાર","Please Touch a donation type":"એક દાન પ્રકાર ટચ કરો","Back":"પાછળ","Enter your details":"તમારી વિગતો દાખલ કરો","Is transaction successful?":"વ્યવહાર સફળ છે?","Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ.":"પી.ડી.ડી.યુ. સાથેની વાતચીત નિષ્ફળ થઈ છે અને ચુકવણી થઇ શકે છે અથવા ન પણ હોઈ શકે. કૃપા કરીને જાતે તપાસ કરો કે ટ્રાન્ઝેક્શન એ PDQ પર સફળ થયું છે.","No":"ના","FAILED":"નિષ્ફળ","Reports Login":"લૉગિન રિપોર્ટ્સ","Last Month":"ગયા મહિને","This Month":"આ મહિને","This Week":"આ અઠવાડિયે","Today":"આજે","Category":"કેટેગરી","Show by":"દ્વારા બતાવો","Week":"અઠવાડિયું","Month":"માસ","Range":"રેંજ","All":"બધા","Success":"સફળતા","Failed":"નિષ્ફળ થયું","Status":"સ્થિતિ","Donation Type":"દાન પ્રકાર","Donation Amount":"દાન રકમ","Date Time":"તારીખ & સમય","Transaction ID":"ટ્રાન્ઝેક્શન આઈડી","View":"જુઓ","EOD Reports":"EOD અહેવાલો","Download":"ડાઉનલોડ કરો","successful":"સફળ","Terminal ID":"ટર્મિનલ ID","Total Since":"ત્યારથી કુલ","Created At":"મુ","No data found":"કોઈ ડેટા મળ્યો નથી","Invalid Login Details.":"અમાન્ય લૉગિન વિગતો.","All Donations are Voluntary , T &amp; C applies":"બધા દાન સ્વૈચ્છિક છે, ટી & સી લાગુ પડે છે","Donation amount can't be 0":"દાન રકમ 0 ન હોઈ શકે","Enter valid terminal ID":"માન્ય ટર્મિનલ ID દાખલ કરો","Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support.":"કૃપા કરીને તપાસો કે PDQ નિષ્ક્રિય છે અને તેની સ્ક્રીન પર કોઈ ક્રિયાને સંકેત આપવામાં આવતી નથી, તેના નેટવર્ક અને પાવર કેબલ યોગ્ય રીતે જોડાયેલ છે અને તે સ્ટેન્ડઅલોન મોડમાં નથી. આ સુનિશ્ચિત કરો કે PDQ વર્તમાનમાં એક બીજા સુધી ઉપયોગમાં નથી. છેલ્લે, PDQ પુનઃપ્રારંભ કરો અને, જો સમસ્યા યથાવત રહે તો, કસ્ટમર સપોર્ટનો સંપર્ક કરો.","Please confirm or change":"કૃપા કરીને પુષ્ટિ કરો અથવા બદલો","From":"થી","New Report":"નવી રિપોર્ટ","RequestInitiated":"અરજીની શરૂઆત","SUCCESSFUL":"સફળ","VOID":"રદબાતલ","Change":"બદલો","Please check your email for receipt.":"કૃપા કરીને રસીદ માટે તમારા ઇમેઇલ તપાસો","Sending email failed.":"ઇમેઇલ મોકલવામાં નિષ્ફળ રહ્યું","Please select a range":"કૃપા કરી શ્રેણી પસંદ કરો","No transactions found":"કોઈ વ્યવહારો મળ્યાં નથી"}

/***/ }),

/***/ "3G/z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3OKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypad_vue__ = __webpack_require__("Akyh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c119ed6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypad_vue__ = __webpack_require__("2eF3");
function injectStyle (ssrContext) {
  __webpack_require__("tU0d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c119ed6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c119ed6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3T4g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_donationOption_vue__ = __webpack_require__("MC5Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84739186_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donationOption_vue__ = __webpack_require__("DlJQ");
function injectStyle (ssrContext) {
  __webpack_require__("UW4e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84739186"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_donationOption_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84739186_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donationOption_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4FMW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_getTerminalId_vue__ = __webpack_require__("Lk/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae27bac0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_getTerminalId_vue__ = __webpack_require__("r5cV");
function injectStyle (ssrContext) {
  __webpack_require__("SvmL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae27bac0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_getTerminalId_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae27bac0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_getTerminalId_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "52ez":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Kq3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6AQ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eodReports_vue__ = __webpack_require__("lDV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41294041_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eodReports_vue__ = __webpack_require__("diJz");
function injectStyle (ssrContext) {
  __webpack_require__("MQ68")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41294041"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eodReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41294041_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eodReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6CT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timer_vue__ = __webpack_require__("cusF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f038ccaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timer_vue__ = __webpack_require__("WbG4");
function injectStyle (ssrContext) {
  __webpack_require__("Yp3o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f038ccaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f038ccaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Fn9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer_vue__ = __webpack_require__("6CT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Languages_vue__ = __webpack_require__("hJCX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setTime: 1,
      timerStart: true,
      failedReason: null,
      paymentId: null,
      tid: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['terminalNotificationStatus', 'token', 'user']), {
    errorMessage: function errorMessage() {
      return 'Transaction has been faild with status "' + this.failedReason + '"';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['resetTerminalNotificationStatus', 'resetEmailStatus', 'updatePaymentRequestStatus', 'changeLoadingStatus']), {
    yes: function yes() {
      var _this = this;

      this.updatePaymentRequestStatus({ id: this.paymentId, status: 'SUCCESSFUL' }).then(function (res) {
        _this.$router.push({ path: '/' + _this.tid + '/thanks-giving/' + _this.donationType + '/' + _this.donationAmount + '/' + _this.paymentId });
      }).catch(function (err) {
        console.log(err);
      });
    },
    no: function no() {
      var _this2 = this;

      this.updatePaymentRequestStatus({ id: this.paymentId, status: 'FAILED' }).then(function (res) {
        _this2.$router.push({ path: '/' + _this2.tid + '/payment-failed/' + _this2.terminalNotificationStatus + '/' + _this2.donationType + '/' + _this2.donationAmount + '/' + _this2.paymentId });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }),
  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_2__timer_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_3__Languages_vue__["a" /* default */]
  },
  mounted: function mounted() {
    var _this3 = this;

    this.resetTerminalNotificationStatus();
    this.setTime = 1;
    this.failedReason = this.$route.params.failedReason;
    this.donationAmount = this.$route.params.donateAmount;
    this.donationType = this.$route.params.donationType;
    this.paymentId = this.$route.params.paymentId;
    this.tid = this.$route.params.terminalId;

    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this3.token) {
        _this3.$router.push({ path: '/' + _this3.tid + '/' });
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        _this3.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "6Hmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetTime; });
/* unused harmony export hostPort */
/* unused harmony export protocol */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return socketHostPort; });
var resetTime = 0.5;
// export const hostPort = 'epod-api.mobileways.tk'
// export const hostPort = '183.82.120.223:8596'
var hostPort = 'api.epodtech.com'; // this domain is configured in freenom for one year; corresponding ip address is 3.8.43.14
var protocol = 'https';

var apiBaseUrl = protocol + '://' + hostPort + '/api';
// export const socketHostPort = `wss://sm958l350000.test.connect.paymentsense.cloud/pac?token=93082359-eede-41fa-9486-c587c72634c6&api-version=v0`
var socketHostPort = 'wss://' + (localStorage.getItem('wss-sockethost') || 'pu749m120000.connect.paymentsense.cloud') + '/pac?token=' + (localStorage.getItem('wss-token') || 'f3924eb0-14a8-4fea-a45b-8a3b8f8ab74e') + '&api-version=v0';

/***/ }),

/***/ "6IUb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_donation_requested_vue__ = __webpack_require__("0PCR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373717ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donation_requested_vue__ = __webpack_require__("ZDuQ");
function injectStyle (ssrContext) {
  __webpack_require__("jIUv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-373717ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_donation_requested_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373717ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donation_requested_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6X1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('div',{staticClass:"payment-failed"},[_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),(_vm.timerStart)?_c('Timer',{attrs:{"setTime":_vm.setTime}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")]),_vm._v(" "),_c('div',{staticClass:"donations-status-sec"},[_c('h3',{staticClass:"in-sentence"},[_vm._v(_vm._s(_vm._f("translate")("Transaction has been failed with status"))+" "),_c('span',{staticClass:"errormsg"},[_vm._v("\""+_vm._s(_vm._f("translate")(_vm.errorMessage))+"\"")])]),_vm._v(" "),_c('h3',{staticClass:"in-sentence-rearange"},[_c('span',[_vm._v(_vm._s(_vm._f("translate")("Transaction has been")))]),_vm._v(" "),_c('span',{staticClass:"errormsg"},[_vm._v("\""+_vm._s(_vm._f("translate")(_vm.errorMessage))+"\"")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("translate")("failed with status")))])]),_vm._v(" "),_c('div',{staticClass:"flex btns-sec"},[_c('div',{staticClass:"btn-bg1 retry"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.tryAgain}},[_vm._v(_vm._s(_vm._f("translate")("Retry")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm._f("translate")("Cancel")))])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6z0a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Fyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputComponent_vue__ = __webpack_require__("WBis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timer_vue__ = __webpack_require__("6CT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Languages__ = __webpack_require__("hJCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__numpad__ = __webpack_require__("1wQF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      amount: null,
      tid: null,
      donationName: null,
      error: null,
      buttonName: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'donationAmount', 'donationType'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'changeDonationAmount', 'changeDonationType', 'changeDonationAmount']), {
    changedAmount: function changedAmount(a) {
      if (a > 5000) {
        this.amount = 5000;
      } else {
        this.amount = +a;
      }
    },
    back: function back() {
      this.$router.go(-1);
    },
    donateAmount: function donateAmount(a) {
      var _this = this;

      if (a !== null && a !== '' && a > 0) {
        // this.changeDonationAmount(+a)
        this.$router.push({ path: '/' + this.tid + '/confirm/' + this.donationType + '/' + this.amount });
      } else {
        if (a === 0) {
          this.error = 'Donation amount can\'t be 0';
        } else {
          this.error = 'Enter your donation amount';
        }
        setTimeout(function () {
          _this.error = false;
        }, 5000);
      }
    }
  }),
  components: {
    InputField: __WEBPACK_IMPORTED_MODULE_2__inputComponent_vue__["a" /* default */],
    Timer: __WEBPACK_IMPORTED_MODULE_3__timer_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_4__Languages__["a" /* default */],
    Numpad: __WEBPACK_IMPORTED_MODULE_5__numpad__["a" /* default */]
  },
  watch: {
    donationName: function donationName(newValue) {
      this.changeDonationType(newValue);
    },
    amount: function amount(newValue) {
      this.changeDonationAmount(newValue);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.donationName = this.$route.params.donationType;
    this.amount = this.$route.params.donationAmount;
    if (this.amount <= 0) {
      this.amount = '';
    }
    this.tid = this.$route.params.terminalId;
    // if (this.$route.params.from === 'amount') {
    //   this.buttonName = 'Continue'
    // } else if (this.$route.params.from === 'confirm') {
    //   this.buttonName = 'Donate'
    //   this.amount = this.$route.params.donationAmount
    // }
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this2.token) {
        _this2.$router.push({ path: '/' + _this2.tid + '/' });
      } else {
        _this2.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "7ckG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__ = __webpack_require__("IToh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d02ce12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__ = __webpack_require__("Xe2j");
function injectStyle (ssrContext) {
  __webpack_require__("cBrV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d02ce12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d02ce12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7kKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen landing-page app-bg-gradient"},[_c('div',{staticClass:"stars"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"landing-row-sec"},[_c('div',{staticClass:"mosque-login-details"},[_c('div',{staticClass:"login"},[_c('loginForm',{attrs:{"token":_vm.token,"userAction":_vm.userAction,"errorMsg":_vm.errorMsg,"buttonName":_vm.btnName},on:{"checkUser":_vm.checkUser}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-left-sec"},[_c('div',{staticClass:"bgimg"},[_c('img',{attrs:{"src":"/static/images/backdrop-mosque.png"}})]),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":"/static/images/logo.png"}}),_vm._v(" "),_c('ul',[_c('li',[_vm._v("lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml")]),_vm._v(" "),_c('li',[_vm._v("lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml")]),_vm._v(" "),_c('li',[_vm._v("lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("gsqX");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "9XAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_optionGroup_vue__ = __webpack_require__("2x9v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4274e667_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_optionGroup_vue__ = __webpack_require__("M1t8");
function injectStyle (ssrContext) {
  __webpack_require__("vVUP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4274e667"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_optionGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4274e667_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_optionGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9lZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A4sB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    value: function value() {
      return this.shiftEnabled ? this.shiftKey : this.normalKey;
    }
  },
  props: ['normalKey', 'shiftKey', 'shiftEnabled'],
  methods: {
    handleClick: function handleClick() {
      this.$emit('click', this.value);
    }
  }
});

/***/ }),

/***/ "Ac+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_translations__ = __webpack_require__("qzYz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_i18n__ = __webpack_require__("kmDT");




var _mutations;








__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuex_i18n__["a" /* default */].plugin, new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store());

var state = {
  language: localStorage.getItem('language') || 'en',
  languages: {
    'en': {
      translations: __webpack_require__("VuCH"),
      dir: 'ltr',
      order: 1
    },
    'ar': {
      translations: __webpack_require__("gbPN"),
      dir: 'rtl',
      order: 2
    },
    'ur': {
      translations: __webpack_require__("IGbK"),
      dir: 'rtl',
      order: 3
    },
    'gu': {
      translations: __webpack_require__("35nI"),
      dir: 'ltr',
      order: 4
    },
    'bn': {
      translations: __webpack_require__("D2pa"),
      dir: 'ltr',
      order: 5
    }
  }
};

for (var ln in state.languages) {
  __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].i18n.add(ln, state.languages[ln].translations);
}

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].i18n.set(state.language);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].i18n.fallback('en');

// getters
var getters = {
  language: function language(state) {
    return state.language;
  },
  languages: function languages(state) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.languages).sort(function (a, b) {
      return state.languages[a].order > state.languages[a].order;
    });
  },
  dir: function dir(state) {
    return state.languages[state.language].dir;
  }
};

var actions = {
  changeLanguage: function changeLanguage(_ref, lang) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* CHANGE_LANGUAGE */], { lang: lang });
  },
  loadTranslations: function loadTranslations(_ref2) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_6__api_translations__["a" /* default */].getTranslations().then(function (a) {
        // commit(types.LOAD_TRANSLATIONS)
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* LOAD_TRANSLATIONS */], a.data);
        // if (a.status === 'Success') {
        //   commit(types.LOAD_TRANSLATIONS_SUCCESS, a)
        //   resolve(a)
        // } else {
        //   commit(types.LOAD_TRANSLATIONS_FAILED, a)
        //   reject(a)
        // }
      }).catch(function (reason) {
        // commit(types.LOAD_TRANSLATIONS_FAILED, reason)
        reject(reason);
      }).finally(function () {});
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* CHANGE_LANGUAGE */], function (state, _ref3) {
  var lang = _ref3.lang;

  state.language = lang;
  __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].i18n.set(lang);
  localStorage.setItem('language', lang);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* LOAD_TRANSLATIONS */], function (state, a) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(a).map(function (lang) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].i18n.add(lang, a[lang]);
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "AdN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputComponent_vue__ = __webpack_require__("WBis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timer_vue__ = __webpack_require__("6CT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Languages__ = __webpack_require__("hJCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__donationOption_vue__ = __webpack_require__("3T4g");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      donationName: null,
      amount: null,
      tid: null,
      donationDetails: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'donationType', 'donationAmount', 'PSSaleRequested', 'paymentRequestStatus', 'donationRequestError'])),
  watch: {
    PSSaleRequested: function PSSaleRequested(newValue) {
      this.startDonationProcess(newValue);
    },
    amount: function amount(newValue) {
      this.changeDonationAmount(newValue);
    },
    donationName: function donationName(newValue) {
      this.changeDonationType(newValue);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'requestPayment', 'changeDonationType', 'changeDonationAmount', 'resetTerminalNotificationStatus']), {
    changedAmount: function changedAmount(a) {
      this.amount = a;
    },
    startDonationProcess: function startDonationProcess(PSSaleRequested) {
      if (PSSaleRequested) {
        this.$router.push({ path: '/' + this.tid + '/payment-confirm/' + this.donationType + '/' + this.donationAmount });
      }
    },
    changeAmountScreen: function changeAmountScreen() {
      this.$router.push({ path: '/' + this.tid + '/change-amount/' + this.donationType + '/' + this.donationAmount });
    },
    back: function back() {
      this.$router.go(-1);
    },
    donateNow: function donateNow() {
      var _this = this;

      if (this.donationAmount !== null && this.donationType !== null) {
        this.requestPayment({
          amount: this.donationAmount,
          socket: this.$socket,
          type: this.donationType
        }).then(function (response) {
          if (_this.PSSaleRequested) {
            _this.startDonationProcess(_this.PSSaleRequested);
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        // TODO: Handle properly.
        console.log('err');
      }
    }
  }),
  components: {
    inputField: __WEBPACK_IMPORTED_MODULE_2__inputComponent_vue__["a" /* default */],
    Timer: __WEBPACK_IMPORTED_MODULE_3__timer_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_4__Languages__["a" /* default */],
    donationOption: __WEBPACK_IMPORTED_MODULE_5__donationOption_vue__["a" /* default */]
  },
  created: function created() {
    this.amount = +this.$route.params.donationAmount;
  },
  mounted: function mounted() {
    var _this2 = this;

    this.donationName = this.$route.params.donationType;
    this.tid = this.$route.params.terminalId;
    this.changeDonationAmount(this.amount);
    this.changeDonationType(this.donationName);
    this.resetTerminalNotificationStatus();
    this.user.data.donationCategories.map(function (category) {
      if (category.title === _this2.donationName) {
        _this2.donationDetails = category;
      } else if (category.childCategories) {
        category.childCategories.map(function (child) {
          if (child.title === _this2.donationName) {
            _this2.donationDetails = child;
          }
        });
      }
    });
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this2.token) {
        _this2.$router.push({ path: '/' + _this2.tid + '/' });
      } else {
        _this2.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "Akyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__key_button_vue__ = __webpack_require__("JZNE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shiftEnabled: false,
      value: '',
      numberKeys: [{ normalKey: '1', shiftKey: '1' }, { normalKey: '2', shiftKey: '2' }, { normalKey: '3', shiftKey: '3' }, { normalKey: '4', shiftKey: '4' }, { normalKey: '5', shiftKey: '5' }, { normalKey: '6', shiftKey: '6' }, { normalKey: '7', shiftKey: '7' }, { normalKey: '8', shiftKey: '8' }, { normalKey: '9', shiftKey: '9' }, { normalKey: '0', shiftKey: '0' }],
      qwertyKeys: [{ normalKey: 'q', shiftKey: 'Q' }, { normalKey: 'w', shiftKey: 'W' }, { normalKey: 'e', shiftKey: 'E' }, { normalKey: 'r', shiftKey: 'R' }, { normalKey: 't', shiftKey: 'T' }, { normalKey: 'y', shiftKey: 'Y' }, { normalKey: 'u', shiftKey: 'U' }, { normalKey: 'i', shiftKey: 'I' }, { normalKey: 'o', shiftKey: 'O' }, { normalKey: 'p', shiftKey: 'P' }],
      asdfKeys: [{ normalKey: 'a', shiftKey: 'A' }, { normalKey: 's', shiftKey: 'S' }, { normalKey: 'd', shiftKey: 'D' }, { normalKey: 'f', shiftKey: 'F' }, { normalKey: 'g', shiftKey: 'G' }, { normalKey: 'h', shiftKey: 'H' }, { normalKey: 'j', shiftKey: 'J' }, { normalKey: 'k', shiftKey: 'K' }, { normalKey: 'l', shiftKey: 'L' }],
      zxcKeys: [{ normalKey: '⇑', shiftKey: '⇧' }, { normalKey: 'z', shiftKey: 'Z' }, { normalKey: 'x', shiftKey: 'X' }, { normalKey: 'c', shiftKey: 'C' }, { normalKey: 'v', shiftKey: 'V' }, { normalKey: 'b', shiftKey: 'B' }, { normalKey: 'n', shiftKey: 'N' }, { normalKey: 'm', shiftKey: 'M' }, { normalKey: '←', shiftKey: '←' }],
      otherKeys: [{ normalKey: 'Space', shiftKey: 'Space' }]

    };
  },

  props: ['editData', 'username'],
  computed: {},
  created: function created() {
    if (this.username === null) {
      this.username = '';
    }
    this.value = this.username;
  },
  methods: {
    clickHandle: function clickHandle(val) {
      if (val === '⇑' || val === '⇧') {
        this.shiftEnabled = !this.shiftEnabled;
        return;
      }
      if (val === '←' && this.value.length) {
        this.value = this.value.split('').splice(0, this.value.length - 1).join('');
      } else if (val === '←') {
        return;
      } else if (val === 'CE') {
        this.value = '';
      } else {
        if (val === 'Space') {
          this.value += ' ';
        } else {
          this.value += val;
        }
      }
      this.$emit('change', this.value);
    }
  },
  components: {
    KeyButton: __WEBPACK_IMPORTED_MODULE_0__key_button_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Am7d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CQRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__key_button_vue__ = __webpack_require__("JZNE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shiftEnabled: false,
      value: '',
      numberKeys: [{ normalKey: '1', shiftKey: '1' }, { normalKey: '2', shiftKey: '2' }, { normalKey: '3', shiftKey: '3' }, { normalKey: '4', shiftKey: '4' }, { normalKey: '5', shiftKey: '5' }, { normalKey: '6', shiftKey: '6' }, { normalKey: '7', shiftKey: '7' }, { normalKey: '8', shiftKey: '8' }, { normalKey: '9', shiftKey: '9' }, { normalKey: '0', shiftKey: '0' }],
      qwertyKeys: [{ normalKey: 'q', shiftKey: 'Q' }, { normalKey: 'w', shiftKey: 'W' }, { normalKey: 'e', shiftKey: 'E' }, { normalKey: 'r', shiftKey: 'R' }, { normalKey: 't', shiftKey: 'T' }, { normalKey: 'y', shiftKey: 'Y' }, { normalKey: 'u', shiftKey: 'U' }, { normalKey: 'i', shiftKey: 'I' }, { normalKey: 'o', shiftKey: 'O' }, { normalKey: 'p', shiftKey: 'P' }],
      asdfKeys: [{ normalKey: 'a', shiftKey: 'A' }, { normalKey: 's', shiftKey: 'S' }, { normalKey: 'd', shiftKey: 'D' }, { normalKey: 'f', shiftKey: 'F' }, { normalKey: 'g', shiftKey: 'G' }, { normalKey: 'h', shiftKey: 'H' }, { normalKey: 'j', shiftKey: 'J' }, { normalKey: 'k', shiftKey: 'K' }, { normalKey: 'l', shiftKey: 'L' }],
      zxcKeys: [{ normalKey: '⇧', shiftKey: '⬆' }, { normalKey: 'z', shiftKey: 'Z' }, { normalKey: 'x', shiftKey: 'X' }, { normalKey: 'c', shiftKey: 'C' }, { normalKey: 'v', shiftKey: 'V' }, { normalKey: 'b', shiftKey: 'B' }, { normalKey: 'n', shiftKey: 'N' }, { normalKey: 'm', shiftKey: 'M' }, { normalKey: '⬅', shiftKey: '⬅' }],
      otherKeys: [{ normalKey: 'Space', shiftKey: 'Space' }]

    };
  },

  props: ['editData', 'username'],
  computed: {},
  created: function created() {
    if (this.username === null) {
      this.username = '';
    }
    this.value = this.username;
  },
  methods: {
    clickHandle: function clickHandle(val) {
      if (val === '⇧' || val === '⬆') {
        this.shiftEnabled = !this.shiftEnabled;
        return;
      }
      if (val === '⬅' && this.value.length) {
        this.value = this.value.split('').splice(0, this.value.length - 1).join('');
      } else if (val === '⬅') {
        return;
      } else if (val === 'CE') {
        this.value = '';
      } else {
        if (val === 'Space') {
          this.value += ' ';
        } else {
          this.value += val;
        }
      }
      this.$emit('change', this.value);
    }
  },
  components: {
    KeyButton: __WEBPACK_IMPORTED_MODULE_0__key_button_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "D2pa":
/***/ (function(module, exports) {

module.exports = {"Mosque Fund":"মসজিদ তহবিল","Masjid Fund":"মসজিদ তহবিল","Sadaqah":"ছাদাক্বা","Zakah":"যাকাত","Other Donations":"অন্যান্য দান","Other":"অন্যান্য","Sadqa-e-Fitr":"ছাদাক্বা-ই-ফিতর","Funeral":"অন্ত্যেষ্টিক্রিয়া","Iftari":"রামজান দ্রুত বিরতি","Masjid Membership":"মসজিদ সদস্যপদ","Madarsah":"স্কুল","Earthquake Appeal":"ভূমিকম্পের আবেদন","Flood Appeal":"বন্যা আপীল","Musallah":"প্রার্থনা কার্পেট","Construction":"নির্মাণ","Fund For Other Masjid":"অন্যান্য মসজিদ জন্য তহবিল","Pay For Imam Salary":"ইমাম বেতন জন্য পেমেন্ট","Forgot Password?":"পাসওয়ার্ড ভুলে গেছেন?","Password":"পাসওয়ার্ড","PIN_ENTRY":"পিন লিখুন","CONNECTING":"সংযুক্ত হচ্ছে","RETRYING":"পুনরায় চেষ্টা করা হচ্ছে","APPROVED":"অনুমোদিত","PLEASE_WAIT":"অনুগ্রহপূর্বক অপেক্ষা করুন","CONNECTION_MADE":"সংযোগ তৈরি করা হয়েছে","PROCESSING_ERROR":"ত্রুটি প্রক্রিয়াকরণ","CARD_ERROR":"কার্ড ত্রুটি","REMOVE_CARD":"কার্ড সরান","SIGNATURE_VERIFICATION_PROCESS_COMPLETED":"স্বাক্ষর যাচাইকরণ প্রক্রিয়া সম্পন্ন","IDLE":"অনুগ্রহপূর্বক অপেক্ষা করুন","INSERT CARD":"ঢোকান কার্ড","INSERT_CARD":"ঢোকান কার্ড","Donations page":"দান পৃষ্ঠা","Thank you for choosing to donate for":"জন্য দান করার জন্য আপনাকে ধন্যবাদ ধন্যবাদ","Please select the amount":"পরিমাণ নির্বাচন করুন","If you wish to donate a different amount, please enter it here":"যদি আপনি একটি ভিন্ন পরিমাণ দান করতে চান, তাহলে এখানে এখানে প্রবেশ করুন","Continue":"চালিয়ে","You are almost done. Please review and confirm":"আপনি প্রায় সম্পন্ন হয়। পর্যালোচনা এবং নিশ্চিত করুন দয়া করে","Login":"লগইন","Logout":"প্রস্থান","Enter valid details":"বৈধ বিবরণ লিখুন","Donations Page":"দান পৃষ্ঠা","Reports":"প্রতিবেদন","Want to change donation":"দান পরিবর্তন করতে চান","you":" আপনি","for":"জন্য","donating":"দান","Donate Now":"এখনি দান করো","Touch / Insert or Swipe your card":"আপনার কার্ড স্পর্শ করুন / ঢোকান বা সোয়াইপ করুন","Transaction has been":"লেনদেন হয়েছে","failed with status":"স্থিতি সঙ্গে ব্যর্থ","CANCELLED":"বাতিল","Cancel":"বাতিল","Retry":"পুনরায় চেষ্টা করা","Remaining Time":"অবশিষ্ট সময়","Thank you for your support":"আপনার সমর্থনের জন্য ধন্যবাদ","Do you want a receipt?":"আপনি একটি রসিদ চান?","Yes":"হাঁ","No, thanks":"না ধন্যবাদ","Send":"পাঠান","You are donating":"আপনি দান করছেন","Transaction has been failed with status":"লেনদেন স্থিতি সঙ্গে ব্যর্থ হয়েছে","WELCOME TO":"স্বাগতম","EVERY":"প্রতি","POUND":"POUND","MATTERS":"ম্যাটার্স","Please Touch a Currency amount":"একটি মুদ্রা পরিমাণ স্পর্শ দয়া করে","Other Amount":"অন্যান্য পরিমাণ","All Donations are Voluntary , T & C applies":"সমস্ত দান স্বেচ্ছাসেবী, টি & সি প্রযোজ্য","Enter your donation amount":"আপনার দান পরিমাণ লিখুন","Donation details":"দান বিবরণ","Confirm":"নিশ্চিত করা","Please review and confirm":"পর্যালোচনা এবং নিশ্চিত করুন দয়া করে","Tap to pay":"পরিশোধ করতে আলতো চাপুন","No, Thanks":"না ধন্যবাদ","Please Touch a donation type":"দয়া করে একটি দান প্রকার স্পর্শ করুন","Back":"পিছনে","Enter your details":"আপনার বিবরণ লিখুন","Is transaction successful?":"আপনার বিবরণ লিখুন","Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ.":"PDQ সঙ্গে যোগাযোগ ব্যর্থ হয়েছে এবং পেমেন্ট বা গ্রহণ করা নাও হতে পারে। PDQ এ লেনদেনটি সফল হলে তা ম্যানুয়ালি চেক করুন।","No":"না","FAILED":"ব্যর্থ","Reports Login":"রিপোর্ট লগইন","Last Month":"গত মাসে","This Month":"এই মাস","This Week":"এই সপ্তাহ","Today":"আজ","Category":"বিভাগ","Show by":"দ্বারা দেখান","Week":"সপ্তাহ","Month":"মাস","Range":"পরিসর","All":"সব","Success":"সাফল্য","Failed":"ব্যর্থ","Status":"অবস্থা","Donation Type":"দান প্রকার","Donation Amount":"দানের পরিমাণ","Date Time":"তারিখ & সময়","Transaction ID":"লেনদেন নাম্বার","View":"দৃশ্য","EOD Reports":"EOD রিপোর্ট","Download":"ডাউনলোড","successful":"সফল","Terminal ID":"টার্মিনাল আইডি","Total Since":"মোট থেকে শুরু","Created At":"এ নির্মিত","No data found":"কোনও তথ্য পাওয়া যায়নি","Invalid Login Details.":"অবৈধ লগইন বিবরণ.","All Donations are Voluntary , T &amp; C applies":"সমস্ত দান স্বেচ্ছাসেবী, টি & সি প্রযোজ্য","Donation amount can't be 0":"অনুদান পরিমাণ 0 হতে পারে না","Enter valid terminal ID":"বৈধ টার্মিন্যাল আইডি লিখুন","Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support.":"দয়া করে চেক করুন যে PDQ নিষ্ক্রিয় আছে এবং তার পর্দায় কোনও পদক্ষেপ নেওয়া হয় না, এটির নেটওয়ার্ক এবং পাওয়ার ক্যাবল সঠিকভাবে সংযুক্ত এবং এটি স্ট্যান্ডআলোন মোডে নয়। এছাড়াও PDQ বর্তমানে পর্যন্ত ব্যবহার করা হয় না তা নিশ্চিত করুন অবশেষে, PDQ পুনঃসূচনা করুন এবং, যদি সমস্যাটি বজায় থাকে তবে দয়া করে গ্রাহক সহায়তার সাথে যোগাযোগ করুন।","Please confirm or change":"নিশ্চিত করুন বা পরিবর্তন করুন","From":"থেকে","New Report":"নতুন প্রতিবেদন","RequestInitiated":"অনুরোধ চালু","SUCCESSFUL":"সফল","VOID":"অকার্যকর","Change":"পরিবর্তন","Please check your email for receipt.":"প্রাপ্তির জন্য আপনার ইমেল চেক করুন।","Sending email failed.":"ইমেল পাঠানো ব্যর্থ হয়েছে","Please select a range":"একটি পরিসীমা নির্বাচন করুন","No transactions found":"কোনও লেনদেন পাওয়া যায় নি"}

/***/ }),

/***/ "DD0r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donation_options_vue__ = __webpack_require__("yMJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdaae672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Donation_options_vue__ = __webpack_require__("2hLf");
function injectStyle (ssrContext) {
  __webpack_require__("gTa7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fdaae672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donation_options_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdaae672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Donation_options_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DQDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numpad-layour"},_vm._l((_vm.keys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,staticClass:"numpad",attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DlJQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donation-details",on:{"click":function($event){_vm.donationTypeSelected(_vm.option)}}},[(_vm.option)?_c('div',{staticClass:"donation-option-details"},[_c('img',{staticClass:"donation-box",attrs:{"src":"/static/images/donation-box.png"}}),_vm._v(" "),_c('div',[_c('img',{staticClass:"donation-type-img",attrs:{"src":_vm.option.image,"id":'image-'+_vm.option.id}})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.option.title)))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LOADING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOADING_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SIGN_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SIGN_IN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SIGN_IN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_DONATIONS_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_DONATIONS_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LOGOUT; });
/* unused harmony export WS_CONNECTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return WS_ADD_REQUEST_TYPE; });
/* unused harmony export WS_REMOVE_REQUEST_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return WS_GET_TERMINAL_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_USER_PDQ_TERMINALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PS_SET_TID; });
/* unused harmony export PS_SET_AVAILABLE_TIDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PAYMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PAYMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PAYMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return WS_PS_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PS_SALE_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PS_SALE_REQUEST_STATUS; });
/* unused harmony export PS_METHOD_TERMINAL_NOTIFICATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EMAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return REPORTS_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return REPORTS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REPORTS_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DECLINED_SIGNATURE_VERIFICATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return REPORTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return REPORTS_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REPORTS_REQUEST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EODREPORTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EODREPORTS_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EODREPORTS_REQUEST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DONATION_REQUEST_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return TERMINAL_NOTIFICATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PAGE_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REPORTS_POPUP_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REPORTS_POPUP_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LOAD_TRANSLATIONS; });
/* unused harmony export LOAD_TRANSLATIONS_SUCCESS */
/* unused harmony export LOAD_TRANSLATIONS_FAILED */
var LOADING_START = 'LOADING_START';
var LOADING_END = 'LOADING_END';

var SIGN_IN = 'SIGN_IN';
var SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
var SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

var CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
var CHANGE_DONATIONS_TYPE = 'CHANGE_DONATIONS_TYPE';
var CHANGE_DONATIONS_AMOUNT = 'CHANGE_DONATIONS_AMOUNT';
var LOGOUT = 'LOGOUT';

var WS_CONNECTED = 'WS_CONNECTED';
var WS_ADD_REQUEST_TYPE = 'WS_ADD_REQUEST_TYPE';
var WS_REMOVE_REQUEST_TYPE = 'WS_REMOVE_REQUEST_TYPE';
var WS_GET_TERMINAL_DETAILS = 'GetTerminalDetails';

var SET_USER_PDQ_TERMINALS = 'SET_USER_PDQ_TERMINALS';
var PS_SET_TID = 'PS_SET_TID';
var PS_SET_AVAILABLE_TIDS = 'PS_SET_AVAILABLE_TIDS';
var PAYMENT = 'PAYMENT';
var PAYMENT_REQUESTED = 'PAYMENT_REQUESTED';
var PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
var PAYMENT_FAILURE = 'PAYMENT_FAILURE';
var WS_PS_SALE = 'WS_PS_SALE';
var PS_SALE_REQUESTED = 'PS_SALE_REQUESTED';
var PS_SALE_REQUEST_STATUS = 'PS_SALE_REQUEST_STATUS';

var PS_METHOD_TERMINAL_NOTIFICATION = 'terminalNotification';

var EMAIL = 'EMAIL';
var EMAIL_SUCCESS = 'EMAIL_SUCCESS';
var EMAIL_FAILURE = 'EMAIL_FAILURE';

var REPORTS_LOGIN = 'REPORTS_LOGIN';
var REPORTS_LOGIN_SUCCESS = 'REPORTS_LOGIN_SUCCESS';
var REPORTS_LOGIN_FAILURE = 'REPORTS_LOGIN_FAILURE';

var DECLINED_SIGNATURE_VERIFICATION_STATUS = 'DECLINED_SIGNATURE_VERIFICATION_STATUS';

var REPORTS_REQUEST = 'REPORTS_REQUEST';
var REPORTS_REQUEST_SUCCESS = 'REPORTS_REQUEST_SUCCESS';
var REPORTS_REQUEST_FAILURE = 'REPORTS_REQUEST_FAILURE';

var EODREPORTS_REQUEST = 'EODREPORTS_REQUEST';
var EODREPORTS_REQUEST_SUCCESS = 'EODREPORTS_REQUEST_SUCCESS';
var EODREPORTS_REQUEST_FAILURE = 'EODREPORTS_REQUEST_FAILURE';

var DONATION_REQUEST_FAILED = 'DONATION_REQUEST_FAILED';

var TERMINAL_NOTIFICATION_STATUS = 'TERMINAL_NOTIFICATION_STATUS';
var PAGE_REDIRECT = 'PAGE_REDIRECT';

var REPORTS_POPUP_SHOW = 'REPORTS_POPUP_SHOW';
var REPORTS_POPUP_HIDE = 'REPORTS_POPUP_HIDE';

var LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';

var LOAD_TRANSLATIONS_SUCCESS = 'LOAD_TRANSLATIONS_SUCCESS';
var LOAD_TRANSLATIONS_FAILED = 'LOAD_TRANSLATIONS_FAILED';

/***/ }),

/***/ "EGAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_No_terminal_vue__ = __webpack_require__("S5XQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6981d1dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_No_terminal_vue__ = __webpack_require__("nJ0U");
function injectStyle (ssrContext) {
  __webpack_require__("jqJn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6981d1dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_No_terminal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6981d1dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_No_terminal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EeoS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keypad__ = __webpack_require__("3OKC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keypad1__ = __webpack_require__("TBQ1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      loginId: null,
      forgotPwText: 'Forgot Password?',
      password: null,
      userNotFount: null,
      editingPlace: 'username'
    };
  },

  computed: {
    editingEnabled: function editingEnabled() {
      return this.editingValue;
    }
  },
  props: ['userAction', 'token', 'errorMsg', 'buttonName'],
  created: function created(e) {
    // console.log(this.userAction, this.token)
  },
  components: {
    Keypad: __WEBPACK_IMPORTED_MODULE_0__keypad__["a" /* default */],
    Keyboard: __WEBPACK_IMPORTED_MODULE_1__keypad1__["a" /* default */]
  },
  methods: {
    changeUserName: function changeUserName(a) {
      this.loginId = a;
    },
    changePassword: function changePassword(a) {
      this.password = a;
    },
    changeEditingField: function changeEditingField(a) {
      this.editingPlace = a;
    },
    loginHandle: function loginHandle(loginId, password) {
      var vm = this;
      if (loginId && password) {
        this.$emit('checkUser', {
          loginId: loginId, password: password
        });
      } else {
        vm.userNotFount = 'Enter valid details';
        setTimeout(function () {
          vm.userNotFount = false;
        }, 3000);
      }
    },
    closePopup: function closePopup() {
      this.$emit('closePopup');
    }
  }
});

/***/ }),

/***/ "F2Mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_reports__ = __webpack_require__("LfxX");




var _mutations;




var state = {
  reportsDetails: JSON.parse(localStorage.getItem('user-store-reports') || '{}'),
  eodReportsDetails: [],
  eodErrorMessage: null,
  showReportsPopup: false
  // getters
};var getters = {
  reportsDetails: function reportsDetails(state) {
    return state.reportsDetails;
  },
  eodReportsDetails: function eodReportsDetails(state) {
    return state.eodReportsDetails;
  },
  eodErrorMessage: function eodErrorMessage(state) {
    return state.eodErrorMessage;
  },
  showReportsPopup: function showReportsPopup(state) {
    return state.showReportsPopup;
  }
};

var actions = {
  reportsLogin: function reportsLogin(_ref, user) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* LOADING_START */]);
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["x" /* REPORTS_LOGIN */]);
    // Now call the login api
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_reports__["a" /* default */].reportsLogin(user).then(function (user) {
        if (user.status === 'Success') {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* REPORTS_LOGIN_SUCCESS */], user);
          resolve(user);
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["y" /* REPORTS_LOGIN_FAILURE */], user.error);
          reject(user);
        }
      }).catch(function (reason) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["y" /* REPORTS_LOGIN_FAILURE */], reason);
        reject(reason);
      }).finally(function () {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* LOADING_END */]);
      });
    });
  },
  reprtsPopupShow: function reprtsPopupShow(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["B" /* REPORTS_POPUP_SHOW */]);
  },
  reprtsPopupHide: function reprtsPopupHide(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["A" /* REPORTS_POPUP_HIDE */]);
  },
  getReportsRange: function getReportsRange(_ref4, range) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* LOADING_START */]);
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* REPORTS_REQUEST */]);
    // Now call the login api
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_reports__["a" /* default */].getReports(range).then(function (range) {
        console.log(range);
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["E" /* REPORTS_REQUEST_SUCCESS */], range);
        resolve(range);
      }).catch(function (reason) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* REPORTS_REQUEST_FAILURE */], reason);
        reject(reason);
      }).finally(function () {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* LOADING_END */]);
      });
    });
  },
  getEODReports: function getEODReports(_ref5, range) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* LOADING_START */]);
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* EODREPORTS_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_reports__["a" /* default */].getEndOfDayReports(range).then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* EODREPORTS_REQUEST_SUCCESS */], res);
        resolve(res);
      }).catch(function (reason) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* EODREPORTS_REQUEST_FAILURE */], reason);
        reject(reason);
      }).finally(function () {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* LOADING_END */]);
      });
    });
  },
  logOut: function logOut(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* LOGOUT */]);
  },
  postEODReports: function postEODReports(_ref7, _ref8) {
    var commit = _ref7.commit;
    var tid = _ref8.tid,
        reports = _ref8.reports;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* LOADING_START */]);
    return __WEBPACK_IMPORTED_MODULE_4__api_reports__["a" /* default */].createEndOfDayReports({ tid: tid, reports: reports }).then(function (result) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* LOADING_END */]);
      return result;
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["x" /* REPORTS_LOGIN */], function (state) {
  state.reportsDetails = {};
  localStorage.setItem('user-store-reports', '{}');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* REPORTS_LOGIN_SUCCESS */], function (state, report) {
  state.reportsDetails = report;
  console.log(report);
  localStorage.setItem('user-store-reports', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(report));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["y" /* REPORTS_LOGIN_FAILURE */], function (state, reason) {
  state.loginFailedStatus = reason.toString();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* REPORTS_REQUEST */], function (state) {
  state.reportsDetails = {};
  localStorage.setItem('user-store-reports', '{}');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["E" /* REPORTS_REQUEST_SUCCESS */], function (state, report) {
  state.reportsDetails = report;
  console.log(report);
  localStorage.setItem('user-store-reports', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(report));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* REPORTS_REQUEST_FAILURE */], function (state, reason) {
  state.loginFailedStatus = reason.toString();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* EODREPORTS_REQUEST */], function (state) {
  state.eodReportsDetails = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* EODREPORTS_REQUEST_SUCCESS */], function (state, Eodreport) {
  state.eodReportsDetails = Eodreport.data || [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* EODREPORTS_REQUEST_FAILURE */], function (state, reason) {
  state.eodErrorMessage = reason.toString();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["B" /* REPORTS_POPUP_SHOW */], function (state) {
  state.showReportsPopup = !state.showReportsPopup;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["A" /* REPORTS_POPUP_HIDE */], function (state) {
  state.showReportsPopup = !state.showReportsPopup;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Languages__ = __webpack_require__("hJCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_constants__ = __webpack_require__("6Hmy");


var _this4 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import noTerminals from './No-terminal'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {
      donationsText: 'Donations Page',
      reportsText: 'Reports',
      checkReports: false,
      userAction: 'Reports',
      errorMsg: false,
      tasksWaitingForSocketConnection: [],
      noTerminalsAvailable: false,
      btnName: 'Continue',
      socketDetailsUpdated: false,
      wssSocketHost: localStorage.getItem('wss-sockethost') || 'sm958l350000.test.connect.paymentsense.cloud',
      wssToken: localStorage.getItem('wss-token') || '93082359-eede-41fa-9486-c587c72634c6',
      terminalId: null,
      terminalID: localStorage.getItem('terminal-id') || '22162165',
      socketError: false,
      configText: 'Config',
      tid: null,
      replaceRoote: null
    };
  },

  created: function created() {
    var _this = this;

    fetch(__WEBPACK_IMPORTED_MODULE_3__api_constants__["a" /* apiBaseUrl */] + '/terminal-details/' + this.$route.params.terminalId, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('user-store-token')
      })
    }).then(function (resp) {
      return resp.json();
    }).then(function (res) {
      if (res.status !== 'Failed') {
        _this.wssSocketHost = res.wss_url;
        _this.wssToken = res.token;
        _this.terminalID = res.tid;
        _this.socketDetailsUpdated = true;

        var socketHost = localStorage.getItem('wss-sockethost');
        var wssToken = localStorage.getItem('wss-token');
        var terminalID = localStorage.getItem('terminal-id');
        var activeTID = localStorage.getItem('user-store-activeTID');

        if (_this.wssSocketHost !== socketHost || _this.wssToken !== wssToken || _this.terminalID !== terminalID || _this.terminalID !== activeTID) {
          _this.setSocketDetails();
        }
      } else {
        if (_this.$route.params.terminalId === '06220842') {
          _this.wssSocketHost = 'sm958l350000.test.connect.paymentsense.cloud';
          _this.wssToken = '93082359-eede-41fa-9486-c587c72634c6';
          _this.terminalID = _this.$route.params.terminalId;
          _this.socketDetailsUpdated = true;

          var _socketHost = localStorage.getItem('wss-sockethost');
          var _wssToken = localStorage.getItem('wss-token');
          var _terminalID = localStorage.getItem('terminal-id');
          var _activeTID = localStorage.getItem('user-store-activeTID');

          if (_this.wssSocketHost !== _socketHost || _this.wssToken !== _wssToken || _this.terminalID !== _terminalID || _this.terminalID !== _activeTID) {
            _this.setSocketDetails();
          }
        } else {
          localStorage.removeItem('wss-sockethost');
          localStorage.removeItem('wss-token');
          localStorage.removeItem('terminal-id');
          localStorage.removeItem('user-store-activeTID');
        }
      }
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'activeTID', 'userPDQTerminals', 'isTerminalAvailable', 'isConnected', 'availableTerminals', 'connectionError', 'showReportsPopup'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'reportsLogin', 'setActiveTID', 'requestTerminalDetails', 'pageRedirect', 'reprtsPopupShow', 'reprtsPopupHide']), {
    setSocketDetails: function setSocketDetails() {
      var _this2 = this;

      if (this.wssSocketHost && this.wssToken && this.terminalID) {
        localStorage.setItem('wss-sockethost', this.wssSocketHost);
        localStorage.setItem('wss-token', this.wssToken);
        localStorage.setItem('terminal-id', this.terminalID);
        localStorage.setItem('user-store-activeTID', this.terminalID);
        this.socketDetailsUpdated = false;
        location.reload();
      } else {
        this.socketError = 'All fields are mandatory';
        setTimeout(function () {
          _this2.socketError = false;
        }, 3000);
      }
    },
    closeNoTerminalsPopup: function closeNoTerminalsPopup() {
      // this.noTerminalsAvailable = false
    },
    showConfigPopup: function showConfigPopup() {
      this.socketDetailsUpdated = true;
    },

    // donationsScreen () {
    //   this.$router.push({name: 'Donations'}, (a) => console.log(arguments))
    // },
    reportsLoginForm: function reportsLoginForm() {
      clearTimeout(this.replaceRoote);
      this.$router.push({ path: '/' + this.tid + '/reports' });
    },
    donationsScreen: function donationsScreen() {
      // this.getTerminalsDetails()
      if (this.isConnected) {
        this.requestTerminalDetails({ socket: this.$socket, terminals: [{ tid: this.terminalId }] });
      } else {
        this.tasksWaitingForSocketConnection.push({
          fn: this.requestTerminalDetails,
          params: [{ socket: this.$socket, terminals: [{ tid: this.terminalId }] }]
        });
      }
    },
    getTerminalsDetails: function getTerminalsDetails() {
      if (this.userPDQTerminals.length > 1) {
        console.log('User has multiple terminals. Choose the terminal you want to use here.');
        // TODO: Handle multiple terminals.
        // this.$router.push({name: 'ChooseTerminal'}, (a) => console.log(arguments))
      } else if (this.isConnected) {
        this.requestTerminalDetails({ socket: this.$socket, terminals: this.userPDQTerminals });
      } else {
        this.tasksWaitingForSocketConnection.push({
          fn: this.requestTerminalDetails,
          params: [{ socket: this.$socket, terminals: this.userPDQTerminals }]
        });
      }
    }
  }),
  watch: {
    isConnected: function isConnected(newValue) {
      if (newValue) {
        while (this.tasksWaitingForSocketConnection.length) {
          var _tasksWaitingForSocke = this.tasksWaitingForSocketConnection.pop(),
              fn = _tasksWaitingForSocke.fn,
              params = _tasksWaitingForSocke.params;

          fn.apply(this, params);
        }
      }
    },
    showReportsPopup: function showReportsPopup(newValue) {
      this.checkReports = newValue;
    },
    connectionError: function connectionError(newValue) {
      if (newValue) {
        alert('Connection error. Please contact support team.');
      }
    },
    userPDQTerminals: function userPDQTerminals(newValue) {
      this.terminalId = newValue[0].tid;
    },
    isTerminalAvailable: function isTerminalAvailable(newValue) {
      if (newValue) {
        // Check wether any terminal is available or not.
        if (this.availableTerminals.length === 0) {
          // TODO: Handle no terminals available case.
          // this.noTerminalsAvailable = true
          console.warn('No terminals available. Please restart the PDQ device and login. Contact support team if you still get this issue.');
          this.changeLoadingStatus(false);
        } else if (this.availableTerminals.length === 1) {
          console.log('User has only one terminal and using that to show donations page.');
          this.setActiveTID(this.availableTerminals[0]);
          this.$router.push({ path: '/' + this.tid + '/donations' });
          // this.$router.push({name: 'Donations'}, (a) => console.log(arguments))
        }
      }
    }
  },
  components: {
    Languages: __WEBPACK_IMPORTED_MODULE_2__Languages__["a" /* default */]
    // noTerminals
  },
  mounted: function mounted() {
    var _this3 = this;

    this.checkReports = this.showReportsPopup;
    this.tid = this.$route.params.terminalId;
    clearTimeout(this.replaceRoote);
    this.replaceRoote = setTimeout(function () {
      _this3.donationsScreen();
      // this.$router.push({path: `/${this.tid}/donations`})
    }, 1000 * 60 * 5);
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this3.token) {
        _this3.$router.push({ path: '/' + _this3.tid + '/' });
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        _this3.terminalId = _this3.$route.params.terminalId;
        _this3.changeLoadingStatus(false);
        window.document.title = _this3.user.data.name;
      }
    });
    this.pageRedirect('reload');
  },
  destroyed: function destroyed() {
    clearTimeout(this.replaceRoote);
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(_this4.replaceRoote);
  }
});

/***/ }),

/***/ "GSS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    progress: function progress(nv) {
      // clear the state.
      this.progress = nv;
      this.draw();
    }
  },
  data: function data() {
    return {
      cx: 29,
      cy: 29,
      cr: 29
    };
  },
  props: ['target', 'progress'],
  computed: {},
  methods: {
    draw: function draw() {
      // debugger
      var progress = this.progress || 0;
      var progressPercent = 2 * Math.PI * progress / this.target - 0.5 * Math.PI;
      var ctx = this.$refs.circleCanvas.getContext('2d');
      ctx.beginPath();
      ctx.moveTo(this.cx, this.cy);
      ctx.arc(this.cx, this.cy, this.cr, progressPercent, 1.5 * Math.PI);
      ctx.moveTo(this.cx, this.cy);
      ctx.fillStyle = '#880913';
      ctx.fill();
    }
  }
});

/***/ }),

/***/ "GkJe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","dir":_vm.dir}},[_c('Loader'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4t6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_form_vue__ = __webpack_require__("esC2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      userAction: 'login',
      errorMsg: false,
      btnName: 'Login',
      tid: null
      // swiperOption: {
      //   autoplay: 3500,
      //   setWrapperSize: true,
      //   observeParents: true,
      //   loop: true
      // },
      // swiperSlides: ['/static/images/slides/slide1n.jpg', '/static/images/slides/slide4n.jpg', '/static/images/slides/slide3n.jpg']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'loginStatus']), {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['login', 'changeLoadingStatus', 'loadTranslations']), {
    checkUser: function checkUser(a) {
      var _this = this;

      var loginId = a.loginId;
      var password = a.password;
      var vm = this;
      if (loginId && password) {
        this.login({ loginId: loginId, password: password }).then(function (as) {
          if (_this.token) {
            console.log(_this.token);
            _this.$router.push({ path: '/' + _this.tid + '/home' });
            // this.$router.push({name: 'Home'}, (a) => console.log(arguments))
          }
        }).catch(function (error) {
          vm.errorMsg = error;
          setTimeout(function () {
            vm.errorMsg = false;
          }, 3000);
        });
      } else {
        vm.userNotFount = 'Enter valid details';
        setTimeout(function () {
          vm.errorMsg = false;
        }, 3000);
      }
    }
  }),
  components: {
    loginForm: __WEBPACK_IMPORTED_MODULE_2__login_form_vue__["a" /* default */]
  },
  mounted: function mounted() {
    var _this2 = this;

    this.tid = this.$route.params.terminalId;
    this.loadTranslations();
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (_this2.token) {
        // console.log(this.user)
        _this2.$router.push({ path: '/' + _this2.tid + '/home' });
        // this.$router.push({name: 'Home'}, (a) => console.log(arguments))
      } else {
        window.document.title = 'EPODTECH';
        _this2.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "IGbK":
/***/ (function(module, exports) {

module.exports = {"Mosque Fund":"مسجد فنڈ","Masjid Fund":"مسجد فنڈ","Sadaqah":"صادق","Zakah":"زکوۃ","Other Donations":"دیگر عطیہ","Other":"دیگر","Sadqa-e-Fitr":"سعدقطر","Funeral":"جنازہ","Iftari":"الإفطار","Masjid Membership":"مسجد کی رکنیت","Madarsah":"مدرسة","Earthquake Appeal":"زلزلے کی اپیل","Flood Appeal":"سیلاب اپیل","Musallah":"مسلاہ","Construction":"تعمیراتی","Fund For Other Masjid":"دوسرے مسجد کے لئے فنڈ","Pay For Imam Salary":"امام تنخواہ کے لئے ادائیگی","Forgot Password?":"پاسورڈ بھول گے؟","Password":"پاسورڈ","PIN_ENTRY":"پن درج کریں","CONNECTING":"منسلک","RETRYING":"ری سیٹنگ","APPROVED":"منظورشدہ","PLEASE_WAIT":"برائے مہربانی انتظار کریں","CONNECTION_MADE":"کنکشن بنایا","PROCESSING_ERROR":"پروسیسنگ کی خرابی","CARD_ERROR":"کارڈ کی خرابی","REMOVE_CARD":"کارڈ کو خارج کر دیں","SIGNATURE_VERIFICATION_PROCESS_COMPLETED":"دستخط کی توثیق کی کارروائی مکمل ہوگئی","IDLE":"برائے مہربانی انتظار کریں","INSERT CARD":"کارڈ ڈالیں","INSERT_CARD":"کارڈ ڈالیں","Donations page":"عطیہ کا صفحہ","Thank you for choosing to donate for":"کے لئے عطیہ کرنے کا انتخاب کرنے کا شکریہ","Please select the amount":"رقم کا انتخاب کریں","If you wish to donate a different amount, please enter it here":"اگر آپ مختلف رقم کا عطیہ کرنا چاہتے ہیں تو، براہ مہربانی یہاں درج کریں","Continue":"جاری رہے","You are almost done. Please review and confirm":"آپ تقریبا کام کر رہے ہیں. براہ کرم جائزہ لیں اور تصدیق کریں","Login":"لاگ ان","Logout":"لاگ آوٹ","Enter valid details":"درست تفصیلات درج کریں","Donations Page":"عطیات صفحہ","Reports":"رپورٹیں","Want to change donation":"عطیہ تبدیل کرنا چاہتے ہیں","you":" آپ","for":" کے لئے","donating":"عطیہ کر رہے ہیں","Donate Now":"ابھی عطیہ کیجیے","Touch / Insert or Swipe your card":"اپنے کارڈ کو ٹچ / ڈالیں یا سوائپ کریں","Transaction has been":"ٹرانزیکشن کی حالت","failed with status":"کے ساتھ ناکام ہوگئی ہے","CANCELLED":"منسوخ","Cancel":"منسوخ کریں","Retry":"دوبارہ کوشش کریں","Remaining Time":"باقی وقت","Thank you for your support":"آپ کی حمایت کا شکریہ","Do you want a receipt?":"کیا آپ ایک رسید چاہتے ہیں؟","Yes":"جی ہاں","No, thanks":"نہیں شکریہ","Send":"بھیجیں","WELCOME TO":"خوش آمدید","EVERY":"ہر کوئی","POUND":"پوڈنڈ","MATTERS":"معاملات","Please Touch a Currency amount":"براہ کرم ایک کرنسی رقم چھو","Other Amount":"دیگر رقم","All Donations are Voluntary , T & C applies":"تمام عطیہ رضاکارانہ ہیں، T & C لاگو ہوتا ہے","Enter your donation amount":"اپنا عطیہ رقم درج کریں","Donation details":"عطیہ کی تفصیلات","Confirm":"تصدیق کریں","Please review and confirm":"براہ کرم جائزہ لیں اور تصدیق کریں","Tap to pay":"ادائیگی کرنے کے لئے ٹپ","No, Thanks":"نہیں شکریہ","Please Touch a donation type":"براہ کرم عطیہ کی قسم چھو","Back":"پیچھے","Enter your details":"اپنی تفصیلات درج کریں","Is transaction successful?":"کیا معاملہ کامیاب ہے؟","Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ.":"PDQ کے ساتھ مواصلات ناکام ہوگئی ہے اور ادائیگی ہو سکتی ہے یا نہیں ہوسکتی ہے. براہ کرم دستی طور پر چیک کریں کہ پی ڈی آر پر ٹرانزیکشن کامیاب تھا.","No":"نہیں","FAILED":"ناکام ہوگیا","Failed":"ناکام","Reports Login":"رپورٹ لاگ ان","Last Month":"پچھلے مہینے","This Month":"اس مہینے","This Week":"اس ہفتے","Today":"آج","Category":"قسم","Show by":"کی طرف سے دکھائیں","Week":"ہفتہ","Month":"مہینہ","Range":"رینج","All":"سب","Success":"کامیابی","Status":"ناکام","Donation Type":"عطیہ کی قسم","Donation Amount":"عطیہ رقم","Date Time":"تاریخ & وقت","Transaction ID":"ٹرانزیکشن کی شناخت","View":"دیکھیں","EOD Reports":"ایڈی رپورٹس","Download":"ڈاؤن لوڈ کریں","successful":"کامیاب","Terminal ID":"ٹرمینل شناخت","Total Since":"کل سے","Created At":"میں پیدا","No data found":"کوئی ڈیٹا نہیں ملا","Invalid Login Details.":"لاگ ان کی غلط تفصیل","All Donations are Voluntary , T &amp; C applies":"تمام عطیہ رضاکارانہ ہیں، T & C لاگو ہوتا ہے","Donation amount can't be 0":"عطیہ رقم 0 نہیں ہوسکتی ہے","Enter valid terminal ID":"درست ٹرمینل کی شناخت درج کریں","Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support.":"براہ کرم چیک کریں کہ PDQ غیر فعال ہے اور اس کی اسکرین پر کوئی کارروائی نہیں کی جارہی ہے، اس کے نیٹ ورک اور پاور کیبل درست طریقے سے منسلک ہیں اور یہ اسٹائل الاؤن موڈ میں نہیں ہے. یہ بھی یقینی بنائیں کہ PDQ فی الحال تک کسی اور میں استعمال نہیں کیا جا رہا ہے. آخر میں، PDQ دوبارہ شروع کریں اور، اگر مسئلہ جاری ہے، تو براہ مہربانی کسٹمر سپورٹ سے رابطہ کریں","Please confirm or change":"براہ مہربانی تصدیق کریں یا تبدیل کریں","From":"سے","New Report":"نئی رپورٹ","RequestInitiated":"درخواست کی شروعات","SUCCESSFUL":"کامیاب","VOID":"بے اثر","Change":"تبدیل کریں","Please check your email for receipt.":"رسید کے لئے اپنا ای میل چیک کریں","Sending email failed.":"ای میل بھیجنے میں ناکامی","Please select a range":"ایک حد منتخب کریں","No transactions found":"کوئی ٹرانسمیشن نہیں ملا"}

/***/ }),

/***/ "IToh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      startOfDayEpoch: null,
      startOfWeekEpoch: null,
      startOfMonthEpoch: null,
      startOfLastMonthEpoch: null,
      transactionsList: null,
      allTransactions: {},
      showBy: 'today',
      previousView: 'today',
      category: 'All',
      status: 'SUCCESSFUL',
      allTransactionsShow: [],
      rangeStartDate: null,
      rangeEndDate: null,
      rangeStartDateEpoch: null,
      rangeEndDateEpoch: null,
      statusCheck: null,
      viewChanges: false,
      dateToday: null,
      minToDate: null,
      rangeChange: false,
      tid: null,
      transactionTotalList: null,
      rangeEmpty: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['user', 'token', 'reportsDetails']), {
    getTransactions: function getTransactions() {
      if (this.viewChanges) {
        if (this.status === 'All') {
          return this.allTransactionsShow || [];
        } else if (this.status === 'SUCCESSFUL') {
          return this.allTransactionsShow.filter(function (a) {
            return a.status === 'SUCCESSFUL';
          });
        } else if (this.status !== 'SUCCESSFUL') {
          return this.allTransactionsShow.filter(function (a) {
            return a.status !== 'SUCCESSFUL';
          });
        }
      } else {
        return this.allTransactionsShow;
      }
    }
  }),
  created: function created() {
    this.startOfDayEpoch = +__WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('day');
    this.startOfWeekEpoch = +__WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('week')._d;
    this.startOfMonthEpoch = +__WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('month')._d;
    this.startOfLastMonthEpoch = +__WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1, 'months').date(1).startOf('day');
    this.dateToday = __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).format('YYYY-MM-DD');
    this.endOfToday = +__WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('day')._d;
    // console.log(this.dateToday)
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'getReportsRange']), {
    changeViewStatus: function changeViewStatus() {
      this.viewChanges = false;
      // console.log(this.viewChanges)
    },
    movetoHome: function movetoHome() {
      this.$router.push({ path: '/' + this.tid + '/home' });
    },
    fromDateChange: function fromDateChange() {
      this.rangeEndDate = null;
      this.minToDate = this.rangeStartDate;
      this.rangeChange = true;
    },
    toDateChange: function toDateChange() {
      this.rangeChange = true;
    },
    DownloadXl: function DownloadXl() {
      var ShowLabel = true;
      var JSONData = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.allTransactionsShow));
      var filename = this.rangeStartDate + 'to' + this.rangeEndDate;
      if (JSONData.length === 0) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(JSONData).map(function (keys) {
        delete JSONData[keys]['date'];
      });
      var arrData = (typeof JSONData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(JSONData)) !== 'object' ? JSON.parse(JSONData) : JSONData;
      var CSV = '';
      if (ShowLabel) {
        // var row = ''
        // // This loop will extract the label from 1st index1 of on array
        // for (var index in arrData[0]) {
        // // Now convert each value to string and comma-seprated
        //   row += index + ','
        // }
        // row = row.slice(0, -1)
        // // append Label row with line break
        // CSV += row + '\r\n'
        CSV += 'Donation Type, Status, Transaction Id, Donation Amount, Date Time' + '\r\n\n';
      }
      var csvData = [];
      // console.log(CSV)
      arrData.map(function (record) {
        // console.log(record)
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(record).map(function (keys) {
          if (keys !== 'ps_reference' && keys !== 'dateString' && keys !== 'amount' && keys !== 'type' && keys !== 'status') {
            delete record[keys];
          }
        });
        csvData.push(record);
      });
      // console.log(csvData)
      // 1st loop is to extract each row
      for (var i = 0; i < csvData.length; i++) {
        // console.log()
        var row1 = '';
        // 2nd loop will extract each column and convert it in string comma-seprated
        for (var index1 in csvData[i]) {
          row1 += '"' + csvData[i][index1] + '",';
        }
        row1.slice(0, row1.length - 1);
        // add a line break after each row1
        CSV += row1 + '\r\n';
      }
      if (CSV === '') {
        alert('Invalid data');
        return;
      }
      // Generate a file name
      var fileName = this.user.data.name;
      // this will remove the blank-spaces from the title and replace it with an underscore
      fileName += filename.replace(/ /g, '_');
      // Initialize file format you want csv or xls
      var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
      //  Now the little tricky part.
      //  you can use either>> window.open(uri);
      //  but this will not work in some browsers
      //  or you will not get the correct file extension
      // this trick will generate a temp <a /> tag
      var link = document.createElement('a');
      link.href = uri;
      // set the visibility hidden so it will not effect on your web-layout
      link.style = 'visibility:hidden';
      link.download = fileName + '.csv';
      // this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // console.log(csvData, CSV)
      // setTimeout(() => {
      //   location.reload()
      // }, 100)
    },
    categoryChange: function categoryChange() {
      var _this = this;

      this.viewChanges = true;
      if (this.showBy === 'range') {
        if (this.rangeStartDate && this.rangeEndDate && this.rangeStartDate <= this.rangeEndDate) {
          this.rangeStartDateEpoch = +__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.rangeStartDate).startOf('day')._d;
          this.rangeEndDateEpoch = +__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.rangeEndDate).endOf('day')._d;
        } else {
          this.rangeEmpty = 'Please select a range';
          setTimeout(function () {
            _this.rangeEmpty = false;
          }, 2000);
          return;
        }
      } else {
        this.rangeStartDate = null;
        this.rangeEndDate = null;
        this.rangeStartDateEpoch = null;
        this.rangeEndDateEpoch = null;
      }
      if (this.previousView === this.showBy && !this.rangeChange) {
        this.filterTransactions();
      } else {
        this.rangeChange = false;
        var range = {};
        if (this.showBy === 'range') {
          range['from'] = this.rangeStartDateEpoch;
          range['to'] = this.rangeEndDateEpoch;
        } else if (this.showBy === 'week') {
          range['from'] = this.startOfWeekEpoch;
          range['to'] = this.endOfToday;
        } else if (this.showBy === 'month') {
          range['from'] = this.startOfMonthEpoch;
          range['to'] = this.endOfToday;
        } else {
          range['from'] = this.startOfDayEpoch;
          range['to'] = this.endOfToday;
        }
        this.getReportsRange(range).then(function (res) {
          _this.getAllReports();
        }).catch(function (error) {
          console.log(error);
        });
      }
      setTimeout(function () {
        _this.viewChanges = false;
      }, 500);
      this.previousView = this.showBy;
    },
    filterTransactions: function filterTransactions() {
      var vm = this;
      vm.allTransactionsShow = vm.transactionTotalList.filter(function (record) {
        // console.log(record)
        if (vm.category === 'All' || record.type === vm.category) {
          var r = vm.checkSortBy(record, vm.showBy, vm.status);
          return r;
        }
      });
      // console.log(vm.allTransactionsShow)
    },
    checkSortBy: function checkSortBy(r, s, status) {
      var record = void 0;
      if (status === 'All' || status !== 'SUCCESSFUL' && r.status !== 'SUCCESSFUL') {
        status = r.status;
      }
      this.statusCheck = status;
      var tTime = r.transactionTime;
      if (s === 'today' && tTime >= this.startOfDayEpoch && status === r.status) {
        // console.log(r.transactionTime)
        // console.log(tTime)
        // console.log((this.startOfDayEpoch))
        record = r;
      } else if (s === 'week' && tTime >= this.startOfWeekEpoch && status === r.status) {
        record = r;
      } else if (s === 'month' && tTime >= this.startOfMonthEpoch && status === r.status) {
        record = r;
      } else if (s === 'range' && tTime >= this.rangeStartDateEpoch && tTime <= this.rangeEndDateEpoch && status === r.status) {
        record = r;
      } else {
        record = null;
      }
      return record;
    },
    gotoEODReports: function gotoEODReports() {
      this.$router.push({ path: '/' + this.tid + '/eodReports' });
    },
    checkReports: function checkReports() {
      this.allTransactions = this.todaysDonation();
    },
    todaysDonation: function todaysDonation() {
      var _this2 = this;

      var list = { 'today': 0, 'week': 0, 'month': 0, 'lastMonth': 0 };
      if (this.transactionsList) {
        this.transactionsList.filter(function (a) {
          return a.status === 'SUCCESSFUL';
        }).map(function (transaction) {
          // console.log(transaction.transactionTime)
          var tTime = transaction.transactionTime;
          if (tTime >= _this2.startOfDayEpoch) {
            list.today = list.today + transaction.amount;
          }
          if (tTime >= _this2.startOfWeekEpoch) {
            list.week = list.week + transaction.amount;
          }
          if (tTime >= _this2.startOfMonthEpoch) {
            list.month = list.month + transaction.amount;
          }
          if (tTime >= _this2.startOfLastMonthEpoch && tTime * 1000 < _this2.startOfMonthEpoch) {
            list.lastMonth = list.lastMonth + transaction.amount;
          }
        });
      }
      this.categoryChange();
      return list;
    },
    getAllReports: function getAllReports() {
      var vm = this;
      vm.transactionsList = this.reportsDetails.data;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.transactionsList).map(function (keys) {
        var val = vm.transactionsList[keys].transactionTime;
        vm.transactionsList[keys]['dateString'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(val).format('DD-MM-YYYY hh:mm A');
      });
      vm.allTransactionsShow = vm.transactionTotalList = vm.transactionsList;
      // console.log(vm.allTransactionsShow)
      vm.checkReports();
    }
  }),
  components: {},
  mounted: function mounted() {
    var _this3 = this;

    this.tid = this.$route.params.terminalId;
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this3.token) {
        _this3.$router.push({ path: '/' + _this3.tid + '/' });
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        _this3.changeLoadingStatus(false);
      }
    });
    var vm = this;
    var from = +__WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('week')._d;
    var to = +__WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('week')._d;
    vm.getReportsRange({ from: from, to: to }).then(function () {
      vm.getAllReports();
    });
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_loader__ = __webpack_require__("V3s/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_socket__ = __webpack_require__("yTez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_i18n__ = __webpack_require__("Ac+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_user__ = __webpack_require__("LWU+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_reports__ = __webpack_require__("F2Mb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_donation_details__ = __webpack_require__("ws6b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_email__ = __webpack_require__("VHlh");











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    loader: __WEBPACK_IMPORTED_MODULE_2__modules_loader__["a" /* default */],
    socket: __WEBPACK_IMPORTED_MODULE_3__modules_socket__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_5__modules_user__["a" /* default */],
    reports: __WEBPACK_IMPORTED_MODULE_6__modules_reports__["a" /* default */],
    donationTypes: __WEBPACK_IMPORTED_MODULE_7__modules_donation_details__["a" /* default */],
    i18n: __WEBPACK_IMPORTED_MODULE_4__modules_i18n__["a" /* default */],
    email: __WEBPACK_IMPORTED_MODULE_8__modules_email__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ "Iw7h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JZNE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_key_button_vue__ = __webpack_require__("A4sB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4771192_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_key_button_vue__ = __webpack_require__("9lZQ");
function injectStyle (ssrContext) {
  __webpack_require__("52ez")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4771192"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_key_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4771192_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_key_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K31e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("I4t6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aa737c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("7kKT");
function injectStyle (ssrContext) {
  __webpack_require__("ZP9T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8aa737c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aa737c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K8dn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"languages"}},[_c('div',{staticClass:"select-box",staticStyle:{"position":"relative"}},[(_vm.isExpand)?_c('languageOptions',{attrs:{"language":_vm.language,"languages":_vm.languages},on:{"languageChange":_vm.languageChange}}):_vm._e()],1),_vm._v(" "),(!_vm.settings)?_c('div',{staticClass:"lang-selected",on:{"click":_vm.changeLang}},[_vm._v(_vm._s(_vm._f("translate")(_vm.selectedLang))+" "),_c('div',{staticClass:"arrow-down"})]):_vm._e(),_vm._v(" "),(_vm.token && !_vm.settings)?_c('div',{staticClass:"logout",on:{"click":_vm.logMeOut}},[_c('img',{attrs:{"src":"/static/images/logout.png"}})]):_vm._e(),_vm._v(" "),(_vm.settings)?_c('img',{staticClass:"settings-icon",attrs:{"src":"/static/images/settings-icon.png"},on:{"click":_vm.checkreLogin}}):_vm._e()]),_vm._v(" "),(_vm.checkReports)?_c('div',{staticClass:"back-drop"}):_vm._e(),_vm._v(" "),(_vm.checkReports)?_c('div',{staticClass:"reports-login"},[_c('loginForm',{attrs:{"token":_vm.token,"userAction":_vm.userAction,"errorMsg":_vm.errorMsg,"buttonName":_vm.btnName},on:{"checkUser":_vm.checkUser,"closePopup":_vm.closePopup}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L7Aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amount_vue__ = __webpack_require__("w87T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d558e26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amount_vue__ = __webpack_require__("+EUx");
function injectStyle (ssrContext) {
  __webpack_require__("lkHK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d558e26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d558e26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LB3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LWU+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_users__ = __webpack_require__("o3g8");




var _mutations;




var state = {
  user: JSON.parse(localStorage.getItem('user-store-user') || '{}'),
  token: localStorage.getItem('user-store-token') || '',
  loginStatus: !!localStorage.getItem('user-store-token'),
  userPDQTerminals: []
};
state.userPDQTerminals = ((state.user.data || {}).terminals || []).sort(function (a) {
  return a.tid;
});
// getters
var getters = {
  user: function user(state) {
    return state.user;
  },
  token: function token(state) {
    return state.token;
  },
  loginStatus: function loginStatus(state) {
    return state.loginStatus;
  },
  userPDQTerminals: function userPDQTerminals(state) {
    return state.userPDQTerminals;
  }
};

var actions = {
  login: function login(_ref, user) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* LOADING_START */]);
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["G" /* SIGN_IN */]);
    // Now call the login api
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_users__["a" /* default */].login(user).then(function (user) {
        if (user.status === 'Failed') {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["H" /* SIGN_IN_FAILURE */], user.error);
          reject(user.error);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["I" /* SIGN_IN_SUCCESS */], user);
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["F" /* SET_USER_PDQ_TERMINALS */], user.data.terminals);
        resolve(user);
      }).catch(function (reason) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["H" /* SIGN_IN_FAILURE */], user.error);
        reject(user.error);
      }).finally(function () {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* LOADING_END */]);
      });
    });
  },
  logOut: function logOut(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* LOGOUT */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["F" /* SET_USER_PDQ_TERMINALS */], function (state, tids) {
  state.userPDQTerminals = tids.sort(function (a) {
    return a.tid;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["G" /* SIGN_IN */], function (state) {
  state.loginStatus = false;
  state.user = {};
  localStorage.setItem('user-store-user', '{}');
  localStorage.setItem('user-store-token', '');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["I" /* SIGN_IN_SUCCESS */], function (state, user) {
  state.user = user;
  localStorage.setItem('user-store-user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(user));
  console.log(user);
  state.token = user.authToken;
  localStorage.setItem('user-store-token', user.authToken);

  state.loginStatus = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["H" /* SIGN_IN_FAILURE */], function (state, reason) {
  state.loginStatus = false;
  state.loginFailedStatus = reason.toString();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* LOGOUT */], function (state) {
  state.user = null;
  state.token = null;
  state.loginStatus = false;
  console.log(state);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "LfxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("6Hmy");



// import moment from 'moment'

function getHeaders() {
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('user-store-token')
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  reportsLogin: function reportsLogin(_ref) {
    var loginId = _ref.loginId,
        password = _ref.password;

    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/auth/user', {
      method: 'POST',
      headers: getHeaders(),
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        username: loginId,
        password: password
      })
    }).then(function (resp) {
      return resp.json();
    }
    // (res) => {
    // resp => resp.json()
    // debugger
    // console.log(res.status
    // return fetch(`${apiBaseUrl}/user/donation/from/${+(moment().startOf('week')._d)}/to/${+(moment().endOf('week')._d)}`, {
    //   method: 'GET',
    //   headers: getHeaders()
    // })
    // .then(resp => resp.json())
    );
  },
  getReports: function getReports(range) {
    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/user/donation/from/' + range.from + '/to/' + range.to, {
      method: 'GET',
      headers: getHeaders()
    }).then(function (resp) {
      return resp.json();
    });
  },
  getEndOfDayReports: function getEndOfDayReports(range) {
    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/user/eod-report/from/' + range.from + '/to/' + range.to, {
      method: 'GET',
      headers: getHeaders()
    }).then(function (resp) {
      return resp.json();
    });
  },
  createEndOfDayReports: function createEndOfDayReports(_ref2) {
    var tid = _ref2.tid,
        reports = _ref2.reports;

    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/user/eod-report/' + tid, {
      method: 'POST',
      headers: getHeaders(),
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        'eod_report': reports
      })
    }).then(function (resp) {
      return resp.json();
    });
  }
});

/***/ }),

/***/ "Lk/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_form_vue__ = __webpack_require__("esC2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      userAction: 'login',
      errorMsg: false,
      tid: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'loginStatus'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus']), {
    setTerminalId: function setTerminalId(a) {
      var vm = this;
      if (a) {
        this.$router.push({ path: '/' + a });
      } else {
        vm.errorMsg = 'Enter valid terminal ID';
        setTimeout(function () {
          vm.errorMsg = false;
        }, 3000);
      }
    }
  }),
  components: {
    loginForm: __WEBPACK_IMPORTED_MODULE_2__login_form_vue__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.tid = this.$route.params.terminalId;
    if (this.tid !== undefined) {
      this.$nextTick(function () {
        // Check wether the user has been already logged in.
        if (_this.token) {
          // console.log(this.user)
          _this.$router.push({ path: '/' + _this.tid + '/' });
          // this.$router.push({name: 'Home'}, (a) => console.log(arguments))
        } else {
          window.document.title = 'EPODTECH';
          _this.changeLoadingStatus(false);
        }
      });
    }
  }
});

/***/ }),

/***/ "M/kg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer_vue__ = __webpack_require__("6CT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Languages__ = __webpack_require__("hJCX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      amount: null,
      donationName: null,
      needRecipt: false,
      userName: null,
      email: null,
      setTime: null,
      timerStart: true,
      tid: null,
      paymentId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'emailStatus'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'sendMail', 'resetEmailStatus']), {
    moveToHome: function moveToHome() {
      localStorage.removeItem('payment-status');
      localStorage.removeItem('payment-req-status');
      localStorage.removeItem('donation-type');
      localStorage.removeItem('donation-amount');
      localStorage.removeItem('email-status');
      this.resetEmailStatus();
      this.$router.push({ path: '/' + this.tid + '/donations' });
    },
    sendRecipt: function sendRecipt() {
      var _this = this;

      var userName = this.userName;
      var email = this.email;
      var donationType = this.donationType;
      var donationAmount = this.donationAmount;
      if (this.userName && this.email) {
        this.sendMail({ userName: userName, email: email, donationType: donationType, donationAmount: donationAmount }).then(function (res) {
          if (res.status === 'Success') {
            setTimeout(function () {
              _this.moveToHome();
            }, 3000);
          } else {}
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    reciptReq: function reciptReq() {
      this.$router.push({ path: '/' + this.tid + '/receipt/' + this.donationName + '/' + this.amount + '/' + this.paymentId });
    }
  }),
  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_2__timer_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_3__Languages__["a" /* default */]
  },
  mounted: function mounted() {
    var _this2 = this;

    this.donationName = this.$route.params.donationType;
    this.amount = this.$route.params.donateAmount;
    this.tid = this.$route.params.terminalId;
    this.paymentId = this.$route.params.paymentId;
    this.setTime = 0.08;
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this2.token) {
        _this2.$router.push({ path: '/' + _this2.tid + '/' });
      } else {
        _this2.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "M1t8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-languages"},_vm._l((_vm.languages),function(lang){return _c('div',{key:lang,staticClass:"language",on:{"click":function($event){_vm.languageSet(lang)}}},[_vm._v(_vm._s(_vm._f("translate")(lang)))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e6c3cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("GkJe");
function injectStyle (ssrContext) {
  __webpack_require__("UFos")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e6c3cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MC5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['option'],
  computed: {},
  methods: {
    donationTypeSelected: function donationTypeSelected(donationType) {
      this.$emit('clickOption', donationType);
    }
  },
  components: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ "MQ68":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_459ecd6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("LB3p");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_459ecd6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_constants__ = __webpack_require__("6Hmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__ = __webpack_require__("U8jO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_rollbar__ = __webpack_require__("eHNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_rollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_rollbar__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_rollbar___default.a, {
  accessToken: '15f06818bba749129296ad7918058c96',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  source_map_enabled: true,
  environment: 'production',
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0'
      }
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default.a, __WEBPACK_IMPORTED_MODULE_4__api_constants__["c" /* socketHostPort */], {
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  format: 'json',
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "QN+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"other-option-sec donation-details"},[_c('div',{staticClass:"donation-option-details"},[_c('img',{staticClass:"donation-box",attrs:{"src":"/static/images/donation-box.png"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm._f("translate")(_vm.childOption.title))+"\n      ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"donation-type-img",staticStyle:{"margin-top":"15px"},attrs:{"src":"/static/images/mosque-fund.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QcUP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S5XQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hidePopup: 'hide'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isTerminalAvailableAfterRequest', 'pageRedirectKey'])),
  watch: {
    isTerminalAvailableAfterRequest: function isTerminalAvailableAfterRequest(newValue) {
      if (!newValue) {
        this.hidePopup = 'show';
      }
    }
  },
  methods: {
    closePopup: function closePopup() {
      switch (this.pageRedirectKey) {
        case 'reload':
          location.reload();
          break;
        default:
          this.$router.push({ name: 'Home' });
          break;
      }
    }
  },
  components: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ "SvmL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TBQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypad1_vue__ = __webpack_require__("CQRX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8971e94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypad1_vue__ = __webpack_require__("0z+Z");
function injectStyle (ssrContext) {
  __webpack_require__("Am7d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8971e94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypad1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8971e94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypad1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UFos":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UW4e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3s/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  loadingStatus: false
  // getters
};var getters = {
  loadingStatus: function loadingStatus(state) {
    return state.loadingStatus;
  }
};

var actions = {
  changeLoadingStatus: function changeLoadingStatus(_ref, status) {
    var commit = _ref.commit;

    commit(status ? __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* LOADING_START */] : __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* LOADING_END */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* LOADING_START */], function (state) {
  state.loadingStatus = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* LOADING_END */], function (state) {
  state.loadingStatus = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_RECONNECT', function SOCKET_RECONNECT(state) {
  state.loadingStatus = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_RECONNECT_ERROR', function SOCKET_RECONNECT_ERROR(state) {
  state.loadingStatus = true;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "VHlh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_email__ = __webpack_require__("afE/");



var _mutations;




var state = {
  emailStatus: JSON.parse(localStorage.getItem('email-status') || null)

  // getters
};var getters = {
  emailStatus: function emailStatus(state) {
    return state.emailStatus;
  }
};

var actions = {
  resetEmailStatus: function resetEmailStatus(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* EMAIL */]);
  },
  sendMail: function sendMail(_ref2, mailDetails) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* EMAIL */]);
    // Now call the payment api
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* LOADING_START */]);
      __WEBPACK_IMPORTED_MODULE_3__api_email__["a" /* default */].sendEmail(mailDetails).then(function (e) {
        if (e.status === 'Success') {
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* EMAIL_SUCCESS */], e.message);
          resolve(e);
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* EMAIL_FAILURE */], e.message);
          reject(e);
        }
      }).catch(function (reason) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* EMAIL_FAILURE */], reason);
        reject(reason);
      }).finally(function () {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* LOADING_END */]);
      });
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* EMAIL */], function (state) {
  state.emailStatus = false;
  localStorage.setItem('email-status', false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* EMAIL_SUCCESS */], function (state, email) {
  state.emailStatus = email;
  localStorage.setItem('email-status', email);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* EMAIL_FAILURE */], function (state, reason) {
  state.emailStatus = false;
  localStorage.setItem('email-status', reason);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "VYnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__key_button_vue__ = __webpack_require__("JZNE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shiftEnabled: false,
      value: '',
      numberKeys: [{ normalKey: '1', shiftKey: '!' }, { normalKey: '2', shiftKey: '`' }, { normalKey: '3', shiftKey: '#' }, { normalKey: '4', shiftKey: '$' }, { normalKey: '5', shiftKey: '%' }, { normalKey: '6', shiftKey: '^' }, { normalKey: '7', shiftKey: '&' }, { normalKey: '8', shiftKey: '*' }, { normalKey: '9', shiftKey: '(' }, { normalKey: '0', shiftKey: ')' }],
      qwertyKeys: [{ normalKey: 'q', shiftKey: 'Q' }, { normalKey: 'w', shiftKey: 'W' }, { normalKey: 'e', shiftKey: 'E' }, { normalKey: 'r', shiftKey: 'R' }, { normalKey: 't', shiftKey: 'T' }, { normalKey: 'y', shiftKey: 'Y' }, { normalKey: 'u', shiftKey: 'U' }, { normalKey: 'i', shiftKey: 'I' }, { normalKey: 'o', shiftKey: 'O' }, { normalKey: 'p', shiftKey: 'P' }],
      asdfKeys: [{ normalKey: 'a', shiftKey: 'A' }, { normalKey: 's', shiftKey: 'S' }, { normalKey: 'd', shiftKey: 'D' }, { normalKey: 'f', shiftKey: 'F' }, { normalKey: 'g', shiftKey: 'G' }, { normalKey: 'h', shiftKey: 'H' }, { normalKey: 'j', shiftKey: 'J' }, { normalKey: 'k', shiftKey: 'K' }, { normalKey: 'l', shiftKey: 'L' }, { normalKey: '_', shiftKey: '+' }],
      zxcKeys: [{ normalKey: '⇑', shiftKey: '⇧' }, { normalKey: 'z', shiftKey: 'Z' }, { normalKey: 'x', shiftKey: 'X' }, { normalKey: 'c', shiftKey: 'C' }, { normalKey: 'v', shiftKey: 'V' }, { normalKey: 'b', shiftKey: 'B' }, { normalKey: 'n', shiftKey: 'N' }, { normalKey: 'm', shiftKey: 'M' }, { normalKey: '.', shiftKey: '.' }, { normalKey: '←', shiftKey: '←' }],
      otherKeys: [{ normalKey: '', shiftKey: '' }, { normalKey: '@', shiftKey: '@' }, { normalKey: 'Space', shiftKey: 'Space' }, { normalKey: '.com', shiftKey: '.com' }, { normalKey: '', shiftKey: '' }]

    };
  },

  props: ['editData', 'emailId'],
  computed: {},
  created: function created() {
    this.value = this.emailId;
  },
  methods: {
    clickHandle: function clickHandle(val) {
      if (val === '⇑' || val === '⇧') {
        this.shiftEnabled = !this.shiftEnabled;
        return;
      }
      if (val === '←' && this.value.length) {
        this.value = this.value.split('').splice(0, this.value.length - 1).join('');
      } else if (val === '←') {
        return;
      } else if (val === 'CE') {
        this.value = '';
      } else {
        if (val === 'Space') {
          this.value += ' ';
        } else {
          this.value += val;
        }
      }
      this.$emit('change', this.value);
    }
  },
  components: {
    KeyButton: __WEBPACK_IMPORTED_MODULE_0__key_button_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "VuCH":
/***/ (function(module, exports) {

module.exports = {"Login Page":"Login Page","te":"తెలుగు","en":"English","ar":"عربى","bn":"বাংলা","ur":"اردو","gu":"ગુજરાતી","Mosque Fund":"Mosque Fund","Masjid Fund":"Masjid Fund","Sadaqah":"Sadaqah","Zakah":"Zakah","Other Donations":"Other Donations","Sadqa-e-Fitr":"Sadqa-e-Fitr","Funeral":"Funeral","Iftari":"Iftari","Masjid Membership":"Masjid Membership","Madarsah":"Madarsah","Earthquake Appeal":"Earthquake Appeal","Flood Appeal":"Flood Appeal","Musallah":"Musallah","Construction":"Construction","Fund For Other Masjid":"Fund For Other Masjid","Pay For Imam Salary":"Pay For Imam Salary","Forgot Password?":"Forgot Password?","Password":"Password","PIN_ENTRY":"Enter PIN","CONNECTING":"Connecting","RETRYING":"Retrying","APPROVED":"Approved","PLEASE_WAIT":"Please wait","CONNECTION_MADE":"Connection made","PROCESSING_ERROR":"Processing error","DECLINED_BY_CARD":"Declined by card","CARD_ERROR":"Card error","REMOVE_CARD":"Remove card","SIGNATURE_VERIFICATION_PROCESS_COMPLETED":"Signature verification process completed","IDLE":"Please wait","INSERT CARD":"Insert card","Donations page":"Donations page","WELCOME TO":"WELCOME TO","EVERY":"EVERY","POUND":"POUND","MATTERS":"MATTERS","Please Touch a Currency amount":"Please Touch a Currency amount","Other Amount":"Other Amount","All Donations are Voluntary , T & C applies":"All Donations are Voluntary , T & C applies","Enter your donation amount":"Enter your donation amount","Donation details":"Donation details","Confirm":"Confirm","Please review and confirm":"Please review and confirm","Tap to pay":"Tap to pay","No, Thanks":"No, Thanks","Please Touch a donation type":"Please Touch a donation type","Back":"Back","Enter your details":"Enter your details","Is transaction successful?":"Is transaction successful?","Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ.":"Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ.","No":"No","FAILED":"FAILED","Reports Login":"Reports Login","Last Month":"Last Month","This Month":"This Month","This Week":"This Week","Today":"Today","Category":"Category","Show by":"Show by","Week":"Week","Month":"Month","Range":"Range","All":"All","Success":"Success","Failed":"Failed","Status":"Status","Donation Type":"Donation Type","Donation Amount":"Donation Amount","Date Time":"Date & Time","Transaction ID":"Transaction ID","View":"View","EOD Reports":"EOD Reports","Download":"Download","successful":"successful","Terminal ID":"Terminal ID","Total Since":"Total Since","Created At":"Created At","No data found":"No data found","Enter valid details":"Enter valid details","Invalid Login Details.":"Invalid Login Details.","All Donations are Voluntary , T &amp; C applies":"All Donations are Voluntary , T & C applies","Donation amount can't be 0":"Donation amount can't be 0","Enter valid terminal ID":"Enter valid terminal ID","Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support.":"Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support.","Retry":"Retry","From":"From","CANCELLED":"CANCELLED","RequestInitiated":"Request Initiated","SUCCESSFUL":"successful","VOID":"void","Please check your email for receipt.":"Please check your email for receipt.","Sending email failed.":"Sending email failed.","Please select a range":"Please select a range","No transactions found":"No transactions found"}

/***/ }),

/***/ "WBis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputComponent_vue__ = __webpack_require__("+IbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6aa83d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputComponent_vue__ = __webpack_require__("2yAW");
function injectStyle (ssrContext) {
  __webpack_require__("w3bf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6aa83d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6aa83d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WbG4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Timer",class:_vm.time<=10 ? 'hurry' : ''},[_c('div',{staticClass:"timer-sec"},[_c('CanvasProgress',{attrs:{"target":_vm.targetTime,"progress":_vm.time}}),_vm._v(" "),_c('div',{staticClass:"image-section"}),_vm._v(" "),_c('div',{staticClass:"elapsedtime"},[_vm._v(_vm._s(_vm.elapsed))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xe2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen reports-section",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('div',{staticClass:"cursor back",on:{"click":_vm.movetoHome}},[_vm._v(_vm._s(_vm._f("translate")("Back")))]),_vm._v(" "),(_vm.allTransactions)?_c('div',{staticClass:"heighlights-section"},[_c('div',{staticClass:"view-heighlight",staticStyle:{"display":"none"}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("translate")("Last Month")))]),_vm._v(" "),_c('span',[_vm._v("£ "+_vm._s(_vm.allTransactions.lastMonth))])])]),_vm._v(" "),_c('div',{staticClass:"view-heighlight"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("translate")("Today"))+" ")]),_vm._v(" "),_c('span',[_vm._v("£ "+_vm._s(_vm.allTransactions.today))])])]),_vm._v(" "),_c('div',{staticClass:"view-heighlight"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("translate")("This Week")))]),_vm._v(" "),_c('span',[_vm._v("£ "+_vm._s(_vm.allTransactions.week))])])]),_vm._v(" "),_c('div',{staticClass:"view-heighlight"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("translate")("This Month")))]),_vm._v(" "),_c('span',[_vm._v("£ "+_vm._s(_vm.allTransactions.month))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"detailed-transactions"},[_c('div',{staticClass:"sort-section"},[_c('div',[_c('div',[_vm._v("\n          "+_vm._s(_vm._f("translate")("Category"))+"\n          "),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category),expression:"category"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.category=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"All"}},[_vm._v(_vm._s(_vm._f("translate")("All")))]),_vm._v(" "),_vm._l((_vm.user.data.donationCategories),function(option){return (option.title !== 'Other Donations')?_c('option',{key:option.title,domProps:{"value":option.title}},[_vm._v(_vm._s(_vm._f("translate")(option.title)))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.user.data.donationCategories),function(option){return (option.title === 'Other Donations')?_c('optgroup',{key:option.title,attrs:{"label":_vm._f("translate")(option.title)}},_vm._l((option.childCategories),function(category){return _c('option',{key:category.title,domProps:{"value":category.title}},[_vm._v(_vm._s(_vm._f("translate")(category.title)))])})):_vm._e()})],2)]),_vm._v(" "),_c('div',[_vm._v("\n          "+_vm._s(_vm._f("translate")("Show by"))+"\n          "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.showBy),expression:"showBy"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.showBy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"today"}},[_vm._v(_vm._s(_vm._f("translate")("Today")))]),_vm._v(" "),_c('option',{attrs:{"value":"week"}},[_vm._v(_vm._s(_vm._f("translate")("Week")))]),_vm._v(" "),_c('option',{attrs:{"value":"month"}},[_vm._v(_vm._s(_vm._f("translate")("Month")))]),_vm._v(" "),_c('option',{attrs:{"value":"range"}},[_vm._v(_vm._s(_vm._f("translate")("Range")))])])]),_vm._v(" "),(_vm.showBy === 'range')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rangeStartDate),expression:"rangeStartDate"}],attrs:{"type":"date","max":_vm.dateToday},domProps:{"value":(_vm.rangeStartDate)},on:{"change":_vm.fromDateChange,"input":function($event){if($event.target.composing){ return; }_vm.rangeStartDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rangeEndDate),expression:"rangeEndDate"}],attrs:{"type":"date","max":_vm.dateToday,"min":_vm.minToDate},domProps:{"value":(_vm.rangeEndDate)},on:{"change":_vm.toDateChange,"input":function($event){if($event.target.composing){ return; }_vm.rangeEndDate=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n          "+_vm._s(_vm._f("translate")("Status"))+"\n          "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"All"}},[_vm._v(_vm._s(_vm._f("translate")("All")))]),_vm._v(" "),_c('option',{attrs:{"value":"SUCCESSFUL"}},[_vm._v(_vm._s(_vm._f("translate")("Success")))]),_vm._v(" "),_c('option',{attrs:{"value":"notSuccess"}},[_vm._v(_vm._s(_vm._f("translate")("Failed")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.categoryChange}},[_vm._v(_vm._s(_vm._f("translate")("View")))])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"btn-bg1 reports-btn"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.gotoEODReports}},[_vm._v(_vm._s(_vm._f("translate")("EOD Reports")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.DownloadXl}},[_vm._v(_vm._s(_vm._f("translate")("Download")))])])])])]),_vm._v(" "),_c('div',{staticClass:"transaction-section"},[_c('div',[_c('div',{staticClass:"transaction-data transaction-data-head"},[_c('div',[_vm._v(_vm._s(_vm._f("translate")("Transaction ID")))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")("Date Time")))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")("Donation Amount")))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")("Donation Type")))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")("Status")))])]),_vm._v(" "),_c('div',{staticClass:"transition-data-section"},[_c('div',{staticClass:"transaction-data"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',[_vm._v("£"+_vm._s(_vm.getTransactions.reduce(function (x, y) { return x + y.amount; }, 0)))]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')]),_vm._v(" "),_vm._l((_vm.getTransactions),function(donation){return (_vm.allTransactionsShow.length > 0)?_c('div',{key:donation.id,staticClass:"transaction-data"},[_c('div',[_vm._v(_vm._s(_vm._f("translate")(donation.ps_reference)))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")(donation.dateString)))]),_vm._v(" "),_c('div',[_vm._v("£"+_vm._s(donation.amount))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")(donation.type)))]),_vm._v(" "),_c('div',{staticClass:"status",class:donation.status},[_c('span',[_vm._v(_vm._s(_vm._f("translate")(donation.status)))])])]):_vm._e()})],2)]),_vm._v(" "),(_vm.allTransactionsShow.length === 0)?_c('div',{staticClass:"full-height flex-center",staticStyle:{"height":"80%"}},[_vm._v("\n        "+_vm._s(_vm._f("translate")("No transactions found"))+"\n      ")]):_vm._e()])])]),_vm._v(" "),(_vm.rangeEmpty)?_c('div',{staticClass:"back-drop"}):_vm._e(),_vm._v(" "),(_vm.rangeEmpty)?_c('div',{staticClass:"error-msg"},[_vm._v("\n      "+_vm._s(_vm._f("translate")(_vm.rangeEmpty))+"\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xgk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XsZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__key_button_vue__ = __webpack_require__("JZNE");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shiftEnabled: false,
      value: '',
      keys: [{ normalKey: 1, shiftKey: 1 }, { normalKey: 2, shiftKey: 2 }, { normalKey: 3, shiftKey: 3 }, { normalKey: 4, shiftKey: 4 }, { normalKey: 5, shiftKey: 5 }, { normalKey: 6, shiftKey: 6 }, { normalKey: 7, shiftKey: 7 }, { normalKey: 8, shiftKey: 8 }, { normalKey: 9, shiftKey: 9 }, { normalKey: 'CE', shiftKey: 'CE' }, { normalKey: 0, shiftKey: 0 }, { normalKey: '←', shiftKey: '←' }]
    };
  },

  props: ['val'],
  computed: {},
  created: function created() {
    this.value = this.val;
  },
  methods: {
    clickHandle: function clickHandle(val) {
      if (val === '←' && this.value.length) {
        this.value = this.value.split('').splice(0, this.value.length - 1).join('');
      } else if (val === '←') {
        return;
      } else if (val === 'CE') {
        this.value = '';
      } else {
        this.value += val;
      }
      if (+this.value >= 5000) {
        this.value = '5000';
      }

      this.$emit('change', this.value);
    }
  },
  components: {
    KeyButton: __WEBPACK_IMPORTED_MODULE_0__key_button_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Donation_options__ = __webpack_require__("DD0r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Amount__ = __webpack_require__("L7Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_confirm_screen__ = __webpack_require__("lD5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_login__ = __webpack_require__("K31e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_getTerminalId__ = __webpack_require__("4FMW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Reports_reports__ = __webpack_require__("7ckG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_donation_requested__ = __webpack_require__("6IUb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_thanks_giving__ = __webpack_require__("re+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_reciept__ = __webpack_require__("rD6c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_payment_failed__ = __webpack_require__("iiLY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_timeout__ = __webpack_require__("aOfE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Reports_eodReports__ = __webpack_require__("6AQ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_amount_change__ = __webpack_require__("ifEM");





















__webpack_require__("v2ns");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/:terminalId/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_6__components_login__["a" /* default */]
  }, {
    path: '/',
    name: 'getTerminalId',
    component: __WEBPACK_IMPORTED_MODULE_7__components_getTerminalId__["a" /* default */]
  }, {
    path: '/:terminalId/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/:terminalId/donations',
    name: 'Donations',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Donation_options__["a" /* default */]
  }, {
    path: '/:terminalId/amount-select/:donationType',
    name: 'Amount',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Amount__["a" /* default */],
    props: true
  }, {
    path: '/:terminalId/change-amount/:donationType/:donationAmount',
    name: 'change-amount',
    component: __WEBPACK_IMPORTED_MODULE_16__components_amount_change__["a" /* default */],
    props: true
  }, {
    path: '/:terminalId/confirm/:donationType/:donationAmount',
    name: 'ConfirmScreen',
    component: __WEBPACK_IMPORTED_MODULE_5__components_confirm_screen__["a" /* default */],
    props: true
  }, {
    path: '/:terminalId/payment-confirm/:donationType/:donateAmount',
    name: 'PaymentConfirm',
    component: __WEBPACK_IMPORTED_MODULE_10__components_donation_requested__["a" /* default */],
    props: true
  }, {
    path: '/:terminalId/thanks-giving/:donationType/:donateAmount/:paymentId',
    name: 'ThanksGiving',
    component: __WEBPACK_IMPORTED_MODULE_11__components_thanks_giving__["a" /* default */],
    props: true
  }, {
    path: '/:terminalId/receipt/:donationType/:donateAmount/:paymentId',
    name: 'Reciept',
    component: __WEBPACK_IMPORTED_MODULE_12__components_reciept__["a" /* default */],
    props: true
  }, {
    // http://localhost:8081/#/22162165/payment-failed/CANCELLED/Zakah/5/293
    path: '/:terminalId/payment-failed/:failedReason/:donationType/:donateAmount/:paymentId',
    name: 'PaymentFailed',
    component: __WEBPACK_IMPORTED_MODULE_13__components_payment_failed__["a" /* default */],
    props: true
  }, {
    path: '/:terminalId/time-out/:failedReason/:donationType/:donateAmount/:paymentId',
    name: 'TimeOut',
    component: __WEBPACK_IMPORTED_MODULE_14__components_timeout__["a" /* default */],
    props: true
  }, {
    path: '/:terminalId/reports',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Reports_reports__["a" /* default */]
  }, {
    path: '/:terminalId/eodReports',
    name: 'EODReports',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Reports_eodReports__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Yp3o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZDuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")]),_vm._v(" "),_c('div',{staticClass:"payment-section"},[((_vm.terminalNotificationStatus === 'PRESENT_CARD'))?_c('div',{staticStyle:{"background-image":"url('/static/images/taptopay.png')"}},[_c('div',[_vm._v(" "+_vm._s(_vm._f("translate")("Tap to pay on terminal")))])]):_vm._e(),_vm._v(" "),((_vm.terminalNotificationStatus !== 'PRESENT_CARD'))?_c('div',{staticStyle:{"background-image":"url('/static/images/enter-pin.png')"}},[_c('div',[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.terminalNotificationStatus)))])]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZE7V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_child_donation_options_vue__ = __webpack_require__("/Qcw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f4268b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_child_donation_options_vue__ = __webpack_require__("QN+u");
function injectStyle (ssrContext) {
  __webpack_require__("Xgk8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14f4268b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_child_donation_options_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f4268b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_child_donation_options_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZP9T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a7k6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aOfE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeout_vue__ = __webpack_require__("6Fn9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78177348_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeout_vue__ = __webpack_require__("cDjA");
function injectStyle (ssrContext) {
  __webpack_require__("omQQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78177348"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78177348_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "acWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "afE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("6Hmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



// const paymentStatus = { 'status': 'Success', 'data': { 'type': 'Zakah', 'terminal_id': 1, 'status': 'CREATED', 'ps_response': null, 'ps_reference': null, 'id': 11, 'amout': 500 } }

function getHeaders() {
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('user-store-token')
  });
}
// const emailStatus = {
//   'status': 'Success',
//   'message': 'Email sent successfully'
// }

/* harmony default export */ __webpack_exports__["a"] = ({
  sendEmail: function sendEmail(_ref) {
    var donationAmount = _ref.donationAmount,
        donationType = _ref.donationType,
        email = _ref.email,
        userName = _ref.userName,
        paymentId = _ref.paymentId;

    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/email/', {
      method: 'POST',
      headers: getHeaders(),
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        donation_type: donationType,
        donation_amount: donationAmount,
        name: userName,
        email: email,
        donation_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).format('DD/MM/YYYY')
      })
    }).then(function (resp) {
      return resp.json();
    });
  }
});

/***/ }),

/***/ "aiGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canvas_progress_vue__ = __webpack_require__("GSS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790e241b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canvas_progress_vue__ = __webpack_require__("dkZz");
function injectStyle (ssrContext) {
  __webpack_require__("a7k6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-790e241b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canvas_progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790e241b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canvas_progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "at0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-class"},[_c('form',{style:({ backgroundColor: (_vm.buttonName === 'Login') ? 'rgba(255,255,255,0.10)' : '#FFF'}),on:{"submit":function($event){$event.preventDefault();_vm.loginHandle(_vm.loginId, _vm.password)}}},[_vm._m(0),_vm._v(" "),(_vm.buttonName === 'Login')?_c('div',{staticClass:"heading heding-color"},[_vm._v(_vm._s(_vm._f("translate")("Login")))]):_vm._e(),_vm._v(" "),(_vm.buttonName !== 'Login')?_c('div',{staticClass:"heading heding-color"},[_vm._v(_vm._s(_vm._f("translate")("Login")))]):_vm._e(),_vm._v(" "),(_vm.buttonName !== 'Login')?_c('div',{staticClass:"cursor close",on:{"click":_vm.closePopup}},[_vm._v("X")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-section top-mrgn input-btm-mrg"},[_c('img',{attrs:{"src":"/static/images/user-icon.png"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginId),expression:"loginId"}],attrs:{"type":"text","id":"login-id","autofocus":"","name":"login_id","autocomplete":"off","placeholder":"Username"},domProps:{"value":(_vm.loginId)},on:{"focus":function($event){_vm.changeEditingField('username')},"input":function($event){if($event.target.composing){ return; }_vm.loginId=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-section"},[_c('img',{attrs:{"src":"/static/images/password-icon.png"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","id":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"focus":function($event){_vm.changeEditingField('password')},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login"},[_vm._v(_vm._s(_vm._f("translate")(_vm.buttonName)))])])]),_vm._v(" "),(_vm.userNotFount && !_vm.errorMsg)?_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm._f("translate")(_vm.userNotFount)))]):_vm._e(),_vm._v(" "),(_vm.errorMsg && !_vm.userNotFount)?_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm._f("translate")(_vm.errorMsg)))]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('input',{attrs:{"type":"hidden","name":"_wpcf7","value":"4"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "byUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cBrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cDjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('div',{staticClass:"payment-failed"},[_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),(_vm.timerStart)?_c('Timer',{attrs:{"setTime":_vm.setTime}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")]),_vm._v(" "),_c('div',{staticClass:"transaction-info"},[_c('div',[_c('em',[_vm._v(_vm._s(_vm._f("translate")("Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ.")))]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('h3',[_vm._v(_vm._s(_vm._f("translate")("Is transaction successful?")))])]),_vm._v(" "),_c('div',{staticClass:"flex btns-sec"},[_c('div',{staticClass:"btn-bg1 yes"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.yes}},[_vm._v(_vm._s(_vm._f("translate")("Yes")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.no}},[_vm._v(_vm._s(_vm._f("translate")("No")))])])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cusF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_constants__ = __webpack_require__("6Hmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__canvas_progress__ = __webpack_require__("aiGe");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      time: __WEBPACK_IMPORTED_MODULE_0__api_constants__["b" /* resetTime */] * 60,
      targetTime: __WEBPACK_IMPORTED_MODULE_0__api_constants__["b" /* resetTime */] * 60,
      timer: null
    };
  },

  watch: {
    setTime: function setTime(newValue) {
      this.restartTimer(newValue);
    }
  },
  props: ['setTime'],
  computed: {
    elapsed: function elapsed() {
      var secs = this.time % 60;
      var mins = (this.time - secs) / 60;
      return (mins > 9 ? mins : '0' + mins) + ':' + (secs > 9 ? secs : '0' + secs);
    }
  },
  created: function created() {
    this.startTimer();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    timeOut: function timeOut() {
      this.time--;
      if (!this.time) {
        this.$router.push({ name: 'Donations' });
      }
    },
    restartTimer: function restartTimer(t) {
      this.time = Math.ceil(t * 60);
    },
    startTimer: function startTimer() {
      var vm = this;
      this.timer = setInterval(vm.timeOut, 1000);
    }
  },
  components: {
    CanvasProgress: __WEBPACK_IMPORTED_MODULE_1__canvas_progress__["a" /* default */]
  }
});

/***/ }),

/***/ "dE3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),_c('Timer'),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")]),_vm._v(" "),_c('div',{staticClass:"amount-details-section"},[_c('div',[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm._f("translate")("Donation details")))]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.donationName),expression:"donationName"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.donationName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._l((_vm.user.data.donationCategories),function(option){return (option.order !== 4)?_c('option',{key:option.title,domProps:{"value":option.title}},[_vm._v(_vm._s(_vm._f("translate")(option.title)))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.user.data.donationCategories),function(option){return (option.order === 4)?_c('optgroup',{key:option.title,attrs:{"label":_vm._f("translate")(option.title)}},_vm._l((option.childCategories),function(category){return _c('option',{key:category.title,domProps:{"value":category.title}},[_vm._v(_vm._s(_vm._f("translate")(category.title)))])})):_vm._e()})],2),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],attrs:{"type":"number","id":"input-amount","step":"1","max":"5000"},domProps:{"value":(_vm.amount)},on:{"changedAmount":_vm.changedAmount,"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"pound-symbol",attrs:{"for":"input-amount"}},[_vm._v("£")]),_vm._v(" "),_c('div',{staticClass:"error"},[_vm._v(" "),(_vm.error)?_c('span',[_vm._v(_vm._s(_vm._f("translate")(_vm.error)))]):_vm._e()])])])]),_vm._v(" "),(_vm.amount !== null)?_c('div',{staticClass:"number-pad-section"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm._f("translate")("Enter your donation amount")))]),_vm._v(" "),_c('Numpad',{attrs:{"val":_vm.amount},on:{"change":_vm.changedAmount}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"other-donation-option"},[_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":function($event){_vm.donateAmount(_vm.amount)}}},[_vm._v(_vm._s(_vm._f("translate")("Continue")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.back}},[_vm._v(_vm._s(_vm._f("translate")("Back")))])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dc1Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('div',{staticClass:"reciept-sec"},[_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),(_vm.timerStart)?_c('Timer',{attrs:{"setTime":_vm.setTime}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"donations-status-sec"},[_c('div',{staticClass:"form-section"},[_c('div',{staticClass:"form-data-section"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm._f("translate")("Enter your details")))]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.sendRecipt()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],attrs:{"type":"text","required":"","placeholder":"Name","autofocus":""},domProps:{"value":(_vm.userName)},on:{"focus":function($event){_vm.changeEditingField('username')},"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","required":"","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"focus":function($event){_vm.changeEditingField('email')},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button-sec"},[_c('div',{staticClass:"no-thanks cursor",on:{"click":_vm.moveToHome}},[_vm._v(_vm._s(_vm._f("translate")("No, Thanks")))]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login"},[_vm._v(_vm._s(_vm._f("translate")("Send")))])])])])]),_vm._v(" "),(_vm.emailStatus)?_c('div',{staticClass:"email-status-sec"},[_c('div',{staticClass:"backdrop"},[_c('div',{staticClass:"email-status"},[_vm._v(_vm._s(_vm._f("translate")(_vm.emailStatus)))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")])]),_vm._v(" "),_c('div',{staticClass:"key-board-section"},[(_vm.editingPlace === 'username')?_c('Keypad',{attrs:{"username":_vm.userName},on:{"change":_vm.changeUserName}}):_vm._e(),_vm._v(" "),(_vm.editingPlace !== 'username')?_c('Keyboard',{attrs:{"emailId":_vm.email},on:{"change":_vm.changeEmail}}):_vm._e()],1)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "diJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen reports-section eod-reports",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('div',{staticClass:"cursor back",on:{"click":_vm.movetoReports}},[_vm._v(_vm._s(_vm._f("translate")("Back")))]),_vm._v(" "),_c('div',{staticClass:"flex flex-between sort-section"},[_c('div',{staticClass:"flex flex-between"},[_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.showBy),expression:"showBy"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.showBy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"today"}},[_vm._v(_vm._s(_vm._f("translate")("Today")))]),_vm._v(" "),_c('option',{attrs:{"value":"week"}},[_vm._v(_vm._s(_vm._f("translate")("Week")))]),_vm._v(" "),_c('option',{attrs:{"value":"range"}},[_vm._v(_vm._s(_vm._f("translate")("Range")))])])]),_vm._v(" "),(_vm.showBy === 'range')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rangeStartDate),expression:"rangeStartDate"}],attrs:{"type":"date","max":_vm.dateToday},domProps:{"value":(_vm.rangeStartDate)},on:{"change":_vm.fromDateChange,"input":function($event){if($event.target.composing){ return; }_vm.rangeStartDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rangeEndDate),expression:"rangeEndDate"}],attrs:{"type":"date","max":_vm.dateToday,"min":_vm.minToDate},domProps:{"value":(_vm.rangeEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rangeEndDate=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-bg1 reports-btn"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.eodReport}},[_vm._v(_vm._s(_vm._f("translate")("EOD Reports")))])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-between relative"},[_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTid),expression:"selectedTid"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTid=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.user.data.terminals),function(terminals){return _c('option',{key:terminals.tid,domProps:{"value":terminals.tid}},[_vm._v(_vm._s(terminals.tid))])}))]),_vm._v(" "),_c('div',{staticClass:"btn-bg1 reports-btn"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.postEodReport}},[_vm._v(_vm._s(_vm._f("translate")("New Report")))])])]),_vm._v(" "),(_vm.terminalReqAvailability)?_c('div',{staticClass:"error danger"},[_vm._v(_vm._s(_vm.terminalReqAvailability))]):_vm._e()])]),_vm._v(" "),(_vm.eodReportsDetails)?_c('div',[_c('div',{staticClass:"width-100"},[(_vm.eodReportsDetails.length > 0)?_c('div',{staticClass:"flex flex-between flex-align-top"},[_c('div',{staticClass:"width-70"},[_c('div',{staticClass:"transaction-data transaction-data-head flex head-row"},[_c('div',[_vm._v(_vm._s(_vm._f("translate")("Terminal ID")))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")("From")))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")("Created At")))])]),_vm._v(" "),_vm._l((_vm.eodReportsDetails),function(report){return _c('div',{key:report.createdAt,on:{"click":function($event){_vm.showFullReport(report)}}},[_c('div',{staticClass:"flex head-row report cursor",class:_vm.activeReportClass(report)},[_c('div',[_vm._v(_vm._s(report.eod_report.tpi))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(report.eod_report.balances.totalsSince))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("moment")(report.createdAt)))])])])})],2),_vm._v(" "),(_vm.activeReportId)?_c('div',{staticClass:"eod-report-box"},[_c('pre',[_vm._v(_vm._s(_vm.activeReportData))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.eodReportsDetails.length <= 0)?_c('div',[_vm._v("\n          "+_vm._s(_vm._f("translate")("No data found"))+"\n        ")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dkZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"circleCanvas",attrs:{"width":"60","height":"60","id":"canvas"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eNMX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "esC2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue__ = __webpack_require__("EeoS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495445bd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_form_vue__ = __webpack_require__("at0v");
function injectStyle (ssrContext) {
  __webpack_require__("vQoT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-495445bd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495445bd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gTa7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gbPN":
/***/ (function(module, exports) {

module.exports = {"Login Page":"صفحة تسجيل الدخول","Mosque Fund":"صندوق المسجد","Masjid Fund":"صندوق المسجد","Sadaqah":"صدقة","Zakah":"الزكاة","Other Donations":"التبرعات الأخرى","Other":"آخر","Sadqa-e-Fitr":"صدقا عيد الفطر","Funeral":"جنازة","Iftari":"الإفطار","Masjid Membership":"عضوية المسجد","Madarsah":"مدرسة","Earthquake Appeal":"نداء الزلزال","Flood Appeal":"الطعن في الفيضانات","Musallah":"سجادة الصلاة","Construction":"اعمال بناء","Fund For Other Masjid":"صدقا عيد الفطر","Pay For Imam Salary":"دفع راتب الإمام","Forgot Password?":"هل نسيت كلمة المرور؟","Password":"كلمه السر","PIN_ENTRY":"أدخل رقم التعريف الشخصي","CONNECTING":"توصيل","RETRYING":"إعادة المحاولة","APPROVED":"وافق","PLEASE_WAIT":"أرجو الإنتظار","CONNECTION_MADE":"أدلى اتصال","PROCESSING_ERROR":"خطأ في المعالجة","CARD_ERROR":"خطأ في بطاقة","REMOVE_CARD":"أزل البطاقة","SIGNATURE_VERIFICATION_PROCESS_COMPLETED":"توقيع التحقق عملية مستوفاة","IDLE":"أرجو الإنتظار","INSERT CARD":"ادرج بطاقة","INSERT_CARD":"ادرج بطاقة","Donations page":"صفحة التبرعات","Thank you for choosing to donate for":"شكرا لاختيارك للتبرع ل","Please select the amount":"يرجى تحديد المبلغ","If you wish to donate a different amount, please enter it here":"إذا كنت ترغب في التبرع بمبلغ مختلف ، يرجى إدخاله هنا","Continue":"استمر","You are almost done. Please review and confirm":"لقد شارفت على الانتهاء. يرجى مراجعة والتأكيد","Login":"تسجيل الدخول","Logout":"الخروج","Enter valid details":"أدخل تفاصيل صالحة","Donations Page":"صفحة التبرعات","Reports":"تقارير","Want to change donation":"تريد تغيير التبرع","you":" أنت","for":" إلى عن على","donating":"تبرع","Donate Now":"تبرع الآن","Touch / Insert or Swipe your card":"المس / أدخل أو مرر بطاقتك","Transaction has been":"الصفقة كانت","failed with status":"فشل مع الوضع","CANCELLED":"ألغيت","Cancel":"إلغاء","Retry":"إعادة المحاولة","Remaining Time":"الوقت المتبقي","Thank you for your support":"شكرا لدعمكم","Do you want a receipt?":"هل تريد إيصال؟","Yes":"نعم فعلا","No, thanks":"نلا شكرا","Send":"إرسال","WELCOME TO":"مرحبا بك في","EVERY":"كل","POUND":"جنيه","MATTERS":"القضايا","Please Touch a Currency amount":"يرجى لمس مبلغ العملة","Other Amount":"كمية اخرى","All Donations are Voluntary , T & C applies":"جميع التبرعات تكون طوعية ، تطبق الشروط والأحكام","Enter your donation amount":"أدخل مبلغ التبرع الخاص بك","Donation details":"تفاصيل التبرع","Confirm":"تؤكد","Please review and confirm":"يرجى مراجعة والتأكيد","Tap to pay":"اضغط على الدفع","No, Thanks":"لا شكرا","Please Touch a donation type":"يرجى لمس نوع التبرع","Back":"الى الخلف","Enter your details":"أدخل التفاصيل الخاصة بك","Is transaction successful?":"هل المعاملة ناجحة؟","Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ.":"فشل الاتصال مع PDQ وقد يكون الدفع قد تم أو لم يتم. يرجى التحقق يدويًا مما إذا كانت المعاملة ناجحة في PDQ.","No":"لا","FAILED":"فشل","Reports Login":"تقارير دخول","Last Month":"الشهر الماضي","This Month":"هذا الشهر","This Week":"هذا الاسبوع","Today":"اليوم","Category":"الفئة","Show by":"عرض من قبل","Week":"أسبوع","Month":"شهر","Range":"نطاق","All":"الكل","Success":"نجاح","Failed":"فشل","Status":"الحالة","Donation Type":"نوع التبرع","Donation Amount":"مبلغ التبرع","Date Time":"تاريخ & الوقت","Transaction ID":"معرف المعاملة","View":"رأي","EOD Reports":"EOD تقارير","Download":"تحميل","successful":"ناجح","Terminal ID":"معرف المحطة","Total Since":"المجموع منذ","Created At":"أنشئت في","No data found":"لاتوجد بيانات","Invalid Login Details.":"تفاصيل تسجيل الدخول غير صالحة","All Donations are Voluntary , T &amp; C applies":"جميع التبرعات تكون طوعية ، تطبق الشروط والأحكام","Donation amount can't be 0":"لا يمكن أن يكون مبلغ التبرع 0","Enter valid terminal ID":"أدخل معرف محطة صالح","Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support.":"يرجى التحقق من أن نظام PDQ في وضع الخمول ولا يتم طلب أي إجراء على شاشته ، وأن شبكته وكبلتي توصيله متصلان بشكل صحيح وأنها ليست في وضع StandAlone. تأكد أيضًا من عدم استخدام PDQ حاليًا في أخرى حتى. وأخيرًا ، أعد تشغيل PDQ ، وإذا استمرت المشكلة ، فيرجى الاتصال بدعم العملاء","Please confirm or change":"يرجى تأكيد أو تغيير","From":"من عند","New Report":"تقرير جديد","RequestInitiated":"طلب البدء","SUCCESSFUL":"ناجح","VOID":"لاغ","Change":"يتغيرون","Please check your email for receipt.":"يرجى التحقق من بريدك الالكتروني لاستلامه","Sending email failed.":"فشل إرسال البريد الإلكتروني","Please select a range":"يرجى تحديد نطاق","No transactions found":"لم يتم العثور على أي معاملات"}

/***/ }),

/***/ "hJCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Languages_vue__ = __webpack_require__("uZfj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b07c237_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Languages_vue__ = __webpack_require__("K8dn");
function injectStyle (ssrContext) {
  __webpack_require__("Iw7h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b07c237"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Languages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b07c237_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Languages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ifEM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amount_change_vue__ = __webpack_require__("7Fyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_165756b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amount_change_vue__ = __webpack_require__("dE3H");
function injectStyle (ssrContext) {
  __webpack_require__("6z0a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-165756b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amount_change_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_165756b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amount_change_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iiLY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_failed_vue__ = __webpack_require__("yLPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb1b918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_failed_vue__ = __webpack_require__("6X1S");
function injectStyle (ssrContext) {
  __webpack_require__("QcUP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9eb1b918"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_failed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb1b918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_failed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jIUv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jqJn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k63O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingStatus),expression:"loadingStatus"}],staticClass:"loader-main"},[_vm._m(0)]),_vm._v(" "),_c('terminalShow')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-loader"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lD5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_screen_vue__ = __webpack_require__("AdN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f8a25e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_screen_vue__ = __webpack_require__("wG4R");
function injectStyle (ssrContext) {
  __webpack_require__("xm4n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21f8a25e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_screen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f8a25e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_screen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lDV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showBy: 'week',
      startOfDayEpoch: null,
      startOfWeekEpoch: null,
      endOfToday: null,
      dateToday: null,
      rangeStartDate: null,
      rangeEndDate: null,
      selectedTid: '22162165',
      activeReportId: null,
      activeReportData: null,
      minToDate: null,
      terminalReqAvailability: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'eodReportsDetails', 'eodReports', 'pageRedirectKey'])),
  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD/MM/YYYY, h:mm');
    }
  },
  watch: {
    pageRedirectKey: function pageRedirectKey(newVal) {
      console.log(newVal);
    },
    eodReports: function eodReports(newValue) {
      var _this = this;

      if (newValue !== undefined) {
        if (newValue.reportType === 'END_OF_DAY') {
          this.postEODReports({ tid: newValue.tpi || newValue.tid, reports: newValue }).then(function (result) {
            console.log(result);
            _this.showBy = 'today';
            _this.eodReport();
          });
        }
      }
    },
    eodReportsDetails: function eodReportsDetails(newValue) {
      if (newValue.length > 0) {
        this.showFullReport(newValue[0]);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getEODReports', 'changeLoadingStatus', 'eodReportRequest', 'postEODReports', 'pageRedirect']), {
    showTerminalStatus: function showTerminalStatus() {
      var _this2 = this;

      this.terminalReqAvailability = 'Terminal not available';
      setTimeout(function () {
        _this2.terminalReqAvailability = false;
      }, 3000);
    },
    activeReportClass: function activeReportClass(currentReport) {
      if (currentReport.id === this.activeReportId) {
        return 'active';
      } else {
        return '';
      }
    },
    showFullReport: function showFullReport(d) {
      this.activeReportData = d.eod_report.reportLines.map(function (a) {
        return a.value;
      }).join('\n').trim();
      this.activeReportId = d.id;
    },
    eodReport: function eodReport(l) {
      var range = {};
      var getReports = false;
      if (l === 'load' || this.showBy === 'week') {
        range['from'] = this.startOfWeekEpoch;
        range['to'] = this.endOfToday;
        getReports = true;
      } else if (this.showBy === 'today') {
        range['from'] = this.startOfDayEpoch;
        range['to'] = this.endOfToday;
        getReports = true;
      } else {
        if (this.rangeStartDate && this.rangeEndDate) {
          range['from'] = +__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.rangeStartDate).startOf('day');
          range['to'] = +__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.rangeEndDate).endOf('day');
          getReports = true;
        }
      }
      if (getReports) {
        this.getEODReports(range).then(function (res) {
          console.log(res);
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    fromDateChange: function fromDateChange() {
      this.rangeEndDate = null;
      this.minToDate = this.rangeStartDate;
    },
    postEodReport: function postEodReport() {
      this.eodReportRequest({
        socket: this.$socket,
        tid: this.selectedTid
      });
    },
    movetoReports: function movetoReports() {
      this.$router.push({ name: 'Reports' });
    }
  }),
  created: function created() {
    this.selectedTid = this.user.data.terminals[0].tid;
    this.startOfDayEpoch = +__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day');
    this.startOfWeekEpoch = +__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('week')._d;
    this.endOfToday = +__WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('day')._d;
    this.dateToday = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).format('YYYY-MM-DD');
  },
  mounted: function mounted() {
    var _this3 = this;

    this.tid = this.$route.params.terminalId;
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this3.token) {
        _this3.$router.push({ path: '/' + _this3.tid + '/' });
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        _this3.changeLoadingStatus(false);
      }
    });
    this.pageRedirect('reload');
    this.eodReport('load');
  }
});

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4b4c37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("+hdf");
function injectStyle (ssrContext) {
  __webpack_require__("uCxN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c4b4c37"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4b4c37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lkHK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mz9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nJ0U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-alert",class:_vm.hidePopup},[_c('div',[_c('div',[_vm._v(_vm._s(_vm._f("translate")("Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support.")))]),_vm._v(" "),_c('div',{staticClass:"close-popup cursor",on:{"click":_vm.closePopup}},[_vm._v(_vm._s(_vm._f("translate")("Retry")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o3g8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("6Hmy");



var scrubDonationCategories = function scrubDonationCategories(allDonationCategories, userDonationCategories) {
  return allDonationCategories.map(function (category) {
    category.childCategories = category.childCategories.filter(function (_ref) {
      var id = _ref.id;
      return userDonationCategories.includes(id);
    });
    return category;
  }).filter(function (_ref2) {
    var id = _ref2.id;
    return userDonationCategories.includes(id);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(_ref3) {
    var loginId = _ref3.loginId,
        password = _ref3.password;

    var headers = new Headers({
      'Content-Type': 'application/json'
    });
    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/auth/user', {
      method: 'POST',
      headers: headers,
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        username: loginId,
        password: password
      })
    }).then(function (res) {
      return res.json();
    }).then(function (res) {
      res.data.donationCategories = scrubDonationCategories(res.data.donationCategories, res.data.otherInfo.donationCategories);
      return res;
    }).catch(function (err) {
      return console.log(err);
    });
  }
});

/***/ }),

/***/ "omQQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_24ee2329_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("mz9q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_24ee2329_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qJeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numpad-layour"},[_c('div',{staticClass:"keypad numbers"},_vm._l((_vm.numberKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return (_vm.editData !== 'username')?_c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}}):_vm._e()})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.qwertyKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.asdfKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad alphabets"},_vm._l((_vm.zxcKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})})),_vm._v(" "),_c('div',{staticClass:"keypad otherkeys otherkeys1"},_vm._l((_vm.otherKeys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qzYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("6Hmy");


// import moment from 'moment'

function getHeaders() {
  return new Headers({
    'Content-Type': 'application/json'
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getTranslations: function getTranslations(range) {
    return fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* apiBaseUrl */] + '/translations', {
      method: 'GET',
      headers: getHeaders()
    }).then(function (resp) {
      return resp.json();
    });
  }
});

/***/ }),

/***/ "r5cV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen landing-page app-bg-gradient"},[_c('div',{staticClass:"stars"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"landing-row-sec"},[_c('div',{staticClass:"mosque-login-details"},[_c('div',{staticClass:"login"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.setTerminalId(_vm.tid)}}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"heading heding-color"},[_vm._v("SET TERMINAL")]),_vm._v(" "),_c('div',{staticClass:"input-section top-mrgn input-btm-mrg"},[_c('img',{attrs:{"src":"/static/images/password-icon.png"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tid),expression:"tid"}],attrs:{"type":"text","id":"tid","name":"tid","placeholder":"Terminal-Id"},domProps:{"value":(_vm.tid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tid=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login"},[_vm._v(_vm._s(_vm._f("translate")("Set Terminal")))])])]),_vm._v(" "),(_vm.errorMsg)?_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm._f("translate")(_vm.errorMsg)))]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-left-sec"},[_c('div',{staticClass:"bgimg"},[_c('img',{attrs:{"src":"/static/images/backdrop-mosque.png"}})]),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":"/static/images/logo.png"}}),_vm._v(" "),_c('ul',[_c('li',[_vm._v("lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml")]),_vm._v(" "),_c('li',[_vm._v("lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml")]),_vm._v(" "),_c('li',[_vm._v("lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('input',{attrs:{"type":"hidden","name":"_wpcf7","value":"4"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rD6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reciept_vue__ = __webpack_require__("uyF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10df7a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reciept_vue__ = __webpack_require__("dc1Z");
function injectStyle (ssrContext) {
  __webpack_require__("acWI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10df7a24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reciept_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10df7a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reciept_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "re+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_thanks_giving_vue__ = __webpack_require__("M/kg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290850f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_thanks_giving_vue__ = __webpack_require__("xiDT");
function injectStyle (ssrContext) {
  __webpack_require__("byUp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290850f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_thanks_giving_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290850f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_thanks_giving_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tU0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uCxN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uExR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__No_terminal__ = __webpack_require__("EGAh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loader',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['loadingStatus'])),
  components: {
    terminalShow: __WEBPACK_IMPORTED_MODULE_2__No_terminal__["a" /* default */]
  }
});

/***/ }),

/***/ "uZfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_optionGroup__ = __webpack_require__("9XAR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_form__ = __webpack_require__("esC2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Languages',
  data: function data() {
    return {
      selectedLang: null,
      la: 'Language',
      lout: 'Logout',
      loadLang: 'load',
      isExpand: false,
      tid: null,
      checkReports: null,
      btnName: 'Continue',
      userAction: '',
      errorMsg: false,
      popupHide: false
    };
  },

  props: ['settings'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['languages', 'language', 'token', 'showReportsPopup'])),
  components: {
    loginForm: __WEBPACK_IMPORTED_MODULE_3__login_form__["a" /* default */],
    languageOptions: __WEBPACK_IMPORTED_MODULE_2__language_optionGroup__["a" /* default */]
  },
  mounted: function mounted() {
    this.selectedLang = this.language;
    document.addEventListener('click', this.documentClick);
    document.addEventListener('touchstart', this.documentClick, false);
    this.tid = this.$route.params.terminalId;
    // console.log(this.showReportsPopup)
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLanguage', 'logOut', 'reprtsPopupShow', 'reportsLogin']), {
    logMeOut: function logMeOut() {
      localStorage.clear();
      this.logOut();
      // else {
      //   this.$router.push({path: `/`})
      // }
      if (this.tid === 'undefined') {
        this.$router.push({ name: 'getTerminalId' });
      } else {
        this.$router.push({ path: '/' + this.tid });
      }
    },
    closePopup: function closePopup() {
      this.checkReports = false;
      clearTimeout(this.popupHide);
    },
    checkreLogin: function checkreLogin() {
      var _this = this;

      this.checkReports = true;
      this.popupHide = setTimeout(function () {
        _this.closePopup();
      }, 1000 * 60 * 2);
    },
    checkUser: function checkUser(a) {
      var _this2 = this;

      var loginId = a.loginId;
      var password = a.password;
      var vm = this;
      this.reportsLogin({ loginId: loginId, password: password }).then(function (res) {
        if (res.status === 'Success') {
          // this.reprtsPopupHide()
          _this2.$router.push({ path: '/' + _this2.tid + '/home' });
          // this.$router.push({name: 'Reports'})
        }
      }).catch(function (error) {
        vm.errorMsg = error.error;
        setTimeout(function () {
          vm.errorMsg = false;
        }, 3000);
      });
    },
    goToHome: function goToHome() {
      // this.reprtsPopupShow()
      this.$router.push({ path: '/' + this.tid });
    },
    changeLang: function changeLang() {
      this.isExpand = true;
    },
    languageChange: function languageChange(a) {
      this.selectedLang = a;
      this.isExpand = false;
      this.changeLanguage(a);
    },
    documentClick: function documentClick(e) {
      // debugger
      var cn = e.target;
      // let cn = document.getElementById('user-section')
      var closestDiv = cn.closest('.lang-selected');
      if (closestDiv !== null && closestDiv !== undefined) {
        this.isExpand = true;
      } else {
        this.isExpand = false;
      }
    }
  })
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uyF8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer_vue__ = __webpack_require__("6CT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Languages__ = __webpack_require__("hJCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keypad__ = __webpack_require__("3OKC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard__ = __webpack_require__("1WYs");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      amount: null,
      donationName: null,
      userName: '',
      email: '',
      setTime: null,
      timerStart: true,
      tid: null,
      paymentId: null,
      dataToChange: '',
      editingPlace: 'username',
      emailStatus: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'sendMail', 'resetEmailStatus']), {
    moveToHome: function moveToHome() {
      localStorage.removeItem('payment-status');
      localStorage.removeItem('payment-req-status');
      localStorage.removeItem('donation-type');
      localStorage.removeItem('donation-amount');
      localStorage.removeItem('email-status');
      this.resetEmailStatus();
      this.$router.push({ path: '/' + this.tid + '/donations' });
    },
    sendRecipt: function sendRecipt() {
      var _this = this;

      var userName = this.userName;
      var email = this.email;
      var donationType = this.donationName;
      var donationAmount = this.amount;
      var paymentId = this.paymentId;
      if (this.userName && this.email) {
        this.sendMail({ userName: userName, email: email, donationType: donationType, donationAmount: donationAmount, paymentId: paymentId }).then(function (res) {
          _this.emailStatus = res.message;
          if (res.status === 'Success') {
            setTimeout(function () {
              _this.emailStatus = false;
              _this.moveToHome();
            }, 3000);
          } else {
            setTimeout(function () {
              _this.emailStatus = false;
            }, 3000);
          }
        }).catch(function (error) {
          _this.emailStatus = error.message;
          setTimeout(function () {
            _this.emailStatus = false;
          }, 3000);
        });
      }
    },
    changeUserName: function changeUserName(a) {
      this.userName = a;
    },
    changeEmail: function changeEmail(a) {
      this.email = a;
    },
    changeEditingField: function changeEditingField(a) {
      this.editingPlace = a;
      if (a === 'username') {
        this.dataToChange = this.userName;
      } else {
        this.dataToChange = this.email;
      }
    }
  }),
  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_2__timer_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_3__Languages__["a" /* default */],
    Keypad: __WEBPACK_IMPORTED_MODULE_4__keypad__["a" /* default */],
    Keyboard: __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */]
  },
  mounted: function mounted() {
    var _this2 = this;

    this.donationName = this.$route.params.donationType;
    this.amount = this.$route.params.donateAmount;
    this.tid = this.$route.params.terminalId;
    this.paymentId = this.$route.params.paymentId;
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this2.token) {
        _this2.$router.push({ path: '/' + _this2.tid + '/' });
      } else {
        _this2.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vQoT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vVUP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vWaf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("6Hmy");



// const paymentStatus = { 'status': 'Success', 'data': { 'type': 'Zakah', 'terminal_id': 1, 'status': 'CREATED', 'ps_response': null, 'ps_reference': null, 'id': 11, 'amout': 500 } }

function getHeaders() {
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('user-store-token')
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  requestPayment: function requestPayment(_ref) {
    var type = _ref.type,
        amount = _ref.amount,
        terminalId = _ref.terminalId;

    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/user/donation', {
      method: 'POST',
      headers: getHeaders(),
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        status: 'Created',
        type: type,
        amount: amount,
        terminal_id: terminalId
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      return response;
    });
  },
  updatePaymentRequest: function updatePaymentRequest(_ref2) {
    var donationId = _ref2.donationId,
        status = _ref2.status,
        ps_reference = _ref2.ps_reference,
        ps_response = _ref2.ps_response;

    return fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* apiBaseUrl */] + '/user/donation/' + donationId, {
      method: 'PUT',
      headers: getHeaders(),
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        id: donationId,
        status: status,
        ps_reference: ps_reference,
        ps_response: ps_response
      })
    }).then(function (response) {
      return response.json().data;
    });
  }
});

/***/ }),

/***/ "w3bf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w87T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputComponent_vue__ = __webpack_require__("WBis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timer_vue__ = __webpack_require__("6CT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Languages__ = __webpack_require__("hJCX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      amount: null,
      donationType: null,
      tid: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'donationAmount'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'changeDonationAmount']), {
    redirectToChangeAmount: function redirectToChangeAmount() {
      this.$router.push({ path: '/' + this.tid + '/change-amount/' + this.donationType + '/0' });
    },
    changedAmount: function changedAmount(a) {
      console.log(a);
      this.amount = a;
    },
    back: function back() {
      this.$router.go(-1);
    },
    donateAmount: function donateAmount(a) {
      if (a !== null && a !== '') {
        // this.changeDonationAmount(+a)
        this.$router.push({ path: '/' + this.tid + '/confirm/' + this.donationType + '/' + a });
      } else {
        console.log('select amount');
      }
    }
  }),
  components: {
    InputField: __WEBPACK_IMPORTED_MODULE_2__inputComponent_vue__["a" /* default */],
    Timer: __WEBPACK_IMPORTED_MODULE_3__timer_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_4__Languages__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.donationType = this.$route.params.donationType;
    this.tid = this.$route.params.terminalId;
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this.token) {
        _this.$router.push({ path: '/' + _this.tid + '/' });
      } else {
        _this.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "wG4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),_c('Timer'),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")]),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v(_vm._s(_vm._f("translate")("Please review and confirm")))]),_vm._v(" "),_c('div',{staticClass:"center in-sentence"},[_vm._v(_vm._s(_vm._f("translate")("You are donating"))+" "),_c('span',[_vm._v("£"+_vm._s(_vm.donationAmount))]),_vm._v(" "+_vm._s(_vm._f("translate")("for"))+" "),_c('span',[_vm._v(_vm._s(_vm._f("translate")(_vm.donationType)))])]),_vm._v(" "),_c('div',{staticClass:"center in-sentence-rearange"},[_vm._v(_vm._s(_vm._f("translate")("you"))),_c('span',[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.donationType))+" ")]),_vm._v(" "+_vm._s(_vm._f("translate")("for"))+" "),_c('span',[_vm._v(" "+_vm._s(_vm.donationAmount)+"£  ")]),_vm._v(" "+_vm._s(_vm._f("translate")("donating")))]),_vm._v(" "),_c('div',{staticClass:"change-desc"},[_vm._v(_vm._s(_vm._f("translate")("Please confirm or change"))+" ")]),_vm._v(" "),_c('div',{staticClass:"reports-section"},[_c('div',{staticClass:"change-details-sec main-donations",on:{"click":_vm.changeAmountScreen}},[_vm._m(0),_vm._v(" "),_c('donationOption',{staticClass:"cursor",attrs:{"option":_vm.donationDetails}})],1),_vm._v(" "),_c('div',{staticClass:"main-donations other-amount-section",on:{"click":_vm.changeAmountScreen}},[(_vm.amount===5)?_c('img',{staticClass:"cursor",attrs:{"src":"static/images/5pounds.png"}}):_vm._e(),_vm._v(" "),(_vm.amount===10)?_c('img',{staticClass:"cursor",attrs:{"src":"static/images/10pounds.png"}}):_vm._e(),_vm._v(" "),(_vm.amount===20)?_c('img',{staticClass:"cursor",attrs:{"src":"static/images/20pounds.png"}}):_vm._e(),_vm._v(" "),(_vm.amount===50)?_c('img',{staticClass:"cursor",attrs:{"src":"static/images/50pounds.png"}}):_vm._e(),_vm._v(" "),((_vm.amount !== 50 && _vm.amount !== 20 && _vm.amount !== 10 && _vm.amount !== 5))?_c('div',{staticClass:"other-amount cursor"},[_vm._v("\n        £ "+_vm._s(_vm.amount)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"donate-now"},[_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.changeAmountScreen}},[_vm._v(_vm._s(_vm._f("translate")("Change")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.donateNow}},[_vm._v(_vm._s(_vm._f("translate")("Confirm")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-bg1"},[_c('div',{staticClass:"btn-bg2"},[_c('button',{staticClass:"cursor login",on:{"click":_vm.back}},[_vm._v(_vm._s(_vm._f("translate")("Back")))])])])]),_vm._v(" "),_c('div',{staticClass:"danger"},[_vm._v(_vm._s(_vm._f("translate")(_vm.donationRequestError)))])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glow"},[_c('img',{attrs:{"src":"/static/images/glow.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wd27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__("uExR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54fb3454_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("k63O");
function injectStyle (ssrContext) {
  __webpack_require__("5Kq3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54fb3454"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54fb3454_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ws6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");



var _mutations;



var state = {
  donationType: null,
  donationAmount: null,
  paymentRequested: false,
  PSSaleRequested: false

  // getters
};var getters = {
  donationType: function donationType(state) {
    return state.donationType;
  },
  donationAmount: function donationAmount(state) {
    return state.donationAmount;
  }
};

var actions = {
  changeDonationType: function changeDonationType(_ref, a) {
    var commit = _ref.commit;

    console.log(a);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* CHANGE_DONATIONS_TYPE */], a);
  },
  changeDonationAmount: function changeDonationAmount(_ref2, a) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CHANGE_DONATIONS_AMOUNT */], a);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* PAYMENT_REQUESTED */], function (state, s) {
  state.paymentRequested = s;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* CHANGE_DONATIONS_TYPE */], function (state, a) {
  state.donationType = a;
  // TODO: Remove this if not required
  localStorage.setItem('donation-type', a);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CHANGE_DONATIONS_AMOUNT */], function (state, a) {
  state.donationAmount = a;
  // TODO: Remove this if not required
  localStorage.setItem('donation-amount', a);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* PAYMENT */], function (state) {
  state.paymentRequestStatus = false;
  state.paymentDoneStatus = null;
  localStorage.setItem('payment-req-status', '');
  localStorage.setItem('payment-status', false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* PAYMENT_SUCCESS */], function (state, paymentObject) {
  state.paymentRequestStatus = paymentObject;
  localStorage.setItem('payment-req-status', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(paymentObject));
  setTimeout(function () {
    state.paymentDoneStatus = true;
    localStorage.setItem('payment-status', true);
  }, 6000);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* PAYMENT_FAILURE */], function (state, reason) {
  state.paymentRequestStatus = false;
  localStorage.setItem('payment-req-status', reason);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader__ = __webpack_require__("wd27");

//
//
//
//
//
//
//
//



// import Languages from './components/Languages'


__webpack_require__("Wiqq");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    // Languages,
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_Loader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['dir']))
});

/***/ }),

/***/ "xiDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen",style:({ backgroundImage: 'url(' + "" + (_vm.user.data.otherInfo['bg-img']) + ')'})},[_c('div',{staticClass:"home-donations app-bg-gradient"},[_c('div',{staticClass:"stars-bg"}),_vm._v(" "),_c('div',{staticClass:"payment-success"},[_c('Languages',{staticClass:"languages",attrs:{"settings":true}}),_vm._v(" "),(_vm.timerStart)?_c('Timer',{attrs:{"setTime":_vm.setTime}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mosque-name"},[_vm._v(_vm._s(_vm.user.data.name))]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm._f("translate")("All Donations are Voluntary , T & C applies"))+" ")]),_vm._v(" "),_c('div',{staticClass:"donations-status-sec"},[_c('h3',[_vm._v(_vm._s(_vm._f("translate")("Thank you for your support")))])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xm4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yLPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer_vue__ = __webpack_require__("6CT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Languages__ = __webpack_require__("hJCX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setTime: 2,
      timerStart: true,
      failedReason: null,
      tid: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'terminalNotificationStatus', 'token']), {
    errorMessage: function errorMessage() {
      return this.failedReason;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['resetTerminalNotificationStatus', 'resetEmailStatus', 'changeLoadingStatus']), {
    tryAgain: function tryAgain() {
      this.$router.push({ path: '/' + this.tid + '/confirm/' + this.$route.params.donationType + '/' + this.$route.params.donateAmount });
    },
    cancel: function cancel() {
      localStorage.removeItem('payment-status');
      localStorage.removeItem('payment-req-status');
      localStorage.removeItem('donation-type');
      localStorage.removeItem('donation-amount');
      localStorage.removeItem('email-status');
      this.resetEmailStatus();
      this.$router.push({ path: '/' + this.tid + '/donations' });
    }
  }),
  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_2__timer_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_3__Languages__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.resetTerminalNotificationStatus();
    this.setTime = 0.25;
    this.failedReason = this.$route.params.failedReason;
    this.tid = this.$route.params.terminalId;

    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this.token) {
        _this.$router.push({ path: '/' + _this.tid + '/' });
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        _this.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "yMJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__donationOption_vue__ = __webpack_require__("3T4g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__child_donation_options_vue__ = __webpack_require__("ZE7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Languages__ = __webpack_require__("hJCX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {
      activeColor: 'red',
      zakathDesc: 'Purify your wealth by giving Zakah',
      zakath: 'Zakah',
      mfund: 'Mosque Fund',
      od: 'Other Donations',
      sadaqah: 'Sadaqah',
      clickOther: false,
      musallah: 'Musallah',
      madarasa: 'Madarasa',
      imamSalary: 'Imam Salary',
      iftiar: 'Iftiar',
      funeral: 'Funeral',
      flods: 'Flods',
      earthQuicks: 'Earth Quicks',
      construction: 'Constructions',
      sadqaEFitr: 'Sadqa-e-Fitr',
      masjidMembership: 'Masjid Membership',
      fundsfOMasques: 'Fund for other mosque',
      tid: null,
      replaceRoote: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'token', 'donationType'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLoadingStatus', 'changeDonationType', 'resetEmailStatus', 'updatePaymentRequestStatus']), {
    activeOtherDonations: function activeOtherDonations() {
      this.clickOther = true;
    },
    backToMainDonations: function backToMainDonations() {
      this.clickOther = false;
      clearTimeout(this.replaceRoote);
    },
    setDonationType: function setDonationType(donation) {
      var _this = this;

      clearTimeout(this.replaceRoote);
      if (donation.id === 4) {
        if (donation.childCategories) {
          this.clickOther = true;
          this.replaceRoote = setTimeout(function () {
            _this.clickOther = false;
          }, 1000 * 60 * 2);
        } else {
          clearTimeout(this.replaceRoote);
          //   this.changeDonationType(donation.title)
          this.$router.push({ path: '/' + this.tid + '/amount-select/' + donation.title });
        }
      } else {
        clearTimeout(this.replaceRoote);
        // this.changeDonationType(donation.title)
        this.$router.push({ path: '/' + this.tid + '/amount-select/' + donation.title });
      }
    }
  }),
  destroyed: function destroyed() {
    clearTimeout(this.replaceRoote);
  },
  components: {
    donationOption: __WEBPACK_IMPORTED_MODULE_2__donationOption_vue__["a" /* default */],
    childDonationOptions: __WEBPACK_IMPORTED_MODULE_3__child_donation_options_vue__["a" /* default */],
    Languages: __WEBPACK_IMPORTED_MODULE_4__Languages__["a" /* default */]
  },
  mounted: function mounted() {
    var _this2 = this;

    localStorage.removeItem('payment-status');
    localStorage.removeItem('payment-req-status');
    localStorage.removeItem('donation-type');
    localStorage.removeItem('donation-amount');
    localStorage.removeItem('email-status');
    // this.updatePaymentRequestStatus('Please wait')
    this.resetEmailStatus();
    this.tid = this.$route.params.terminalId;
    this.$nextTick(function () {
      // Check wether the user has been already logged in.
      if (!_this2.token) {
        _this2.$router.push({ path: '/' + _this2.tid + '/' });
      } else {
        _this2.changeLoadingStatus(false);
      }
    });
  }
});

/***/ }),

/***/ "yTez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_donations__ = __webpack_require__("vWaf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);



var _mutations;





var getRandomRequestId = function getRandomRequestId() {
  return Math.ceil(+new Date() / 1000) % 1000000;
};

var state = {
  socket: {
    isConnected: false,
    message: '',
    reconnectError: false,
    connectionError: true
  },
  requestTypes: {},
  isTerminalAvailable: false,
  activeTID: null,
  availableTerminals: [],
  PSSaleRequested: false,
  terminalNotificationStatus: 'IDLE',
  PSSaleRequestStatus: null,
  donationRequestError: null,
  declineSignatureRequiredTransaction: false,
  declineSignatureRequiredTransactionId: -1,
  eodReports: {},
  isTerminalAvailableAfterRequest: true,
  pageRedirectKey: false,
  PSSaleRequestResponse: {}
};

var getters = {
  isConnected: function isConnected() {
    return state.socket.isConnected;
  },
  isTerminalAvailable: function isTerminalAvailable() {
    return state.isTerminalAvailable;
  },
  availableTerminals: function availableTerminals() {
    return state.availableTerminals;
  },
  activeTID: function activeTID() {
    return state.activeTID || localStorage.getItem('user-store-activeTID') || null;
  },
  PSSaleRequested: function PSSaleRequested() {
    return state.PSSaleRequested;
  },
  terminalNotificationStatus: function terminalNotificationStatus() {
    return state.terminalNotificationStatus;
  },
  PSSaleRequestStatus: function PSSaleRequestStatus() {
    return state.PSSaleRequestStatus;
  },
  PSSaleRequestResponse: function PSSaleRequestResponse() {
    return state.PSSaleRequestResponse;
  },
  connectionError: function connectionError() {
    return state.socket.connectionError;
  },
  donationRequestError: function donationRequestError() {
    return state.donationRequestError;
  },
  declineSignatureRequiredTransaction: function declineSignatureRequiredTransaction() {
    return state.declineSignatureRequiredTransaction;
  },
  declineSignatureRequiredTransactionId: function declineSignatureRequiredTransactionId() {
    return state.declineSignatureRequiredTransactionId;
  },
  eodReports: function eodReports() {
    return state.eodReports;
  },
  isTerminalAvailableAfterRequest: function isTerminalAvailableAfterRequest() {
    return state.isTerminalAvailableAfterRequest;
  },
  pageRedirectKey: function pageRedirectKey() {
    return state.pageRedirectKey;
  }
};

var actions = {
  setActiveTID: function setActiveTID(_ref, _ref2) {
    var commit = _ref.commit;
    var tpi = _ref2.tpi,
        tid = _ref2.tid;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* PS_SET_TID */], { tid: tid || tpi });
  },
  resetTerminalNotificationStatus: function resetTerminalNotificationStatus(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["J" /* TERMINAL_NOTIFICATION_STATUS */], 'Please wait');
  },
  resetPSSaleRequestStatus: function resetPSSaleRequestStatus(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* PS_SALE_REQUEST_STATUS */], null);
  },
  updatePaymentRequestStatus: function updatePaymentRequestStatus(_ref5, _ref6) {
    var commit = _ref5.commit;
    var id = _ref6.id,
        status = _ref6.status;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["J" /* TERMINAL_NOTIFICATION_STATUS */], status);
    return __WEBPACK_IMPORTED_MODULE_3__api_donations__["a" /* default */].updatePaymentRequest({
      status: status,
      donationId: id
    });
  },
  declineSignatureVerification: function declineSignatureVerification(_ref7, _ref8) {
    var commit = _ref7.commit;
    var socket = _ref8.socket;

    if (getters.isConnected() && getters.declineSignatureRequiredTransactionId() !== -1) {
      socket.sendObj({
        'jsonrpc': '2.0',
        'id': getters.declineSignatureRequiredTransactionId(),
        'result': { 'accepted': false }
      });
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* DECLINED_SIGNATURE_VERIFICATION_STATUS */]);
    }
  },
  requestTerminalDetails: function requestTerminalDetails(_ref9, _ref10) {
    var commit = _ref9.commit;
    var socket = _ref10.socket,
        terminals = _ref10.terminals;

    var type = __WEBPACK_IMPORTED_MODULE_2__mutation_types__["L" /* WS_GET_TERMINAL_DETAILS */];
    var requestId = getRandomRequestId();
    commit('SET_TERMINAL_AVAILABLE_STATUS', { status: false });
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["K" /* WS_ADD_REQUEST_TYPE */], { requestId: requestId, type: type });

    if (getters.isConnected()) {
      socket.sendObj({
        'jsonrpc': '2.0',
        'method': 'terminalsDetails',
        'params': {
          'tpiList': terminals.map(function (t) {
            return t.tid;
          }),
          'status': 'AVAILABLE'
        },
        'id': requestId
      });
    } else {
      console.warn('Called before socket is available.');
    }
  },
  updateDonationRequest: function updateDonationRequest(_, response) {
    response = response || state.PSSaleRequestResponse;
    return __WEBPACK_IMPORTED_MODULE_3__api_donations__["a" /* default */].updatePaymentRequest({
      status: Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(response, 'transactionResult', 'FAILED'),
      ps_reference: response.transactionId || 'NA',
      ps_response: response || {},
      terminalId: getters.activeTID(),
      donationId: response.id
    });
  },
  requestPayment: function requestPayment(_ref11, _ref12) {
    var commit = _ref11.commit;
    var amount = _ref12.amount,
        type = _ref12.type,
        socket = _ref12.socket;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* LOADING_START */]);
    return __WEBPACK_IMPORTED_MODULE_3__api_donations__["a" /* default */].requestPayment({ amount: amount, type: type, terminalId: getters.activeTID() }).then(function (res) {
      if (res.status === 'Success') {
        var result = res.data;
        var requestId = result.id;
        var _type = __WEBPACK_IMPORTED_MODULE_2__mutation_types__["M" /* WS_PS_SALE */];
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* PAYMENT_REQUESTED */], true);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["K" /* WS_ADD_REQUEST_TYPE */], { requestId: requestId, type: _type });
        if (getters.isConnected()) {
          socket.sendObj({
            'jsonrpc': '2.0',
            'method': 'sale',
            'params': {
              'tpi': getters.activeTID(),
              'currency': 'GBP',
              'amount': amount * 100
            },
            'id': requestId
          });

          actions.updateDonationRequest({}, { transactionResult: 'RequestInitiated', id: requestId });
        } else {
          // console.warn('Called before socket is available.')
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* LOADING_END */]);
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* DONATION_REQUEST_FAILED */], res.message);
        }
      } else {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* LOADING_END */]);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* DONATION_REQUEST_FAILED */], res.errors);
      }
    }).catch(function (error) {
      // TODO: handle if socket is not connected.
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* LOADING_END */]);
      console.warn(error.message);
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* DONATION_REQUEST_FAILED */], error.message);
    }).finally(function () {
      // commit(types.LOADING_END)
    });
  },
  eodReportRequest: function eodReportRequest(_ref13, _ref14) {
    var commit = _ref13.commit;
    var socket = _ref14.socket,
        tid = _ref14.tid;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* LOADING_START */]);
    var type = __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* EODREPORTS_REQUEST */];
    var requestId = getRandomRequestId();
    // commit(types.EODREPORTS_REQUEST, true)
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["K" /* WS_ADD_REQUEST_TYPE */], { requestId: requestId, type: type });
    if (getters.isConnected()) {
      socket.sendObj({
        'jsonrpc': '2.0',
        'method': 'reportEndOfDay',
        'params': {
          'tpi': tid
        },
        'id': requestId
      });
    } else {
      // console.warn('Called before socket is available.')
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* EODREPORTS_REQUEST_FAILURE */], 'No Connection');
    }
  },
  pageRedirect: function pageRedirect(_ref15, val) {
    var commit = _ref15.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* PAGE_REDIRECT */], val);
  }
};

var mutations = (_mutations = {
  SET_TERMINAL_AVAILABLE_STATUS: function SET_TERMINAL_AVAILABLE_STATUS(state, _ref16) {
    var status = _ref16.status;

    state.isTerminalAvailable = status;
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* PAGE_REDIRECT */], function (state, val) {
  state.pageRedirectKey = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* PS_SALE_REQUEST_STATUS */], function (state, status) {
  state.PSSaleRequestStatus = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* PS_SET_TID */], function (state, _ref17) {
  var tid = _ref17.tid;

  state.activeTID = tid;
  localStorage.setItem('user-store-activeTID', tid);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* PS_SALE_REQUESTED */], function (state, s) {
  state.PSSaleRequested = s;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["K" /* WS_ADD_REQUEST_TYPE */], function (state, _ref18) {
  var requestId = _ref18.requestId,
      type = _ref18.type;

  state.requestTypes[requestId] = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* DONATION_REQUEST_FAILED */], function (state, reason) {
  state.donationRequestError = reason;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["J" /* TERMINAL_NOTIFICATION_STATUS */], function (state, val) {
  state.terminalNotificationStatus = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONOPEN', function SOCKET_ONOPEN(state, event) {
  state.socket.isConnected = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONCLOSE', function SOCKET_ONCLOSE(state, event) {
  state.socket.isConnected = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONERROR', function SOCKET_ONERROR(state, event) {
  state.socket.isConnected = false;
  state.socket.connectionError = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* DECLINED_SIGNATURE_VERIFICATION_STATUS */], function (state) {
  state.declineSignatureRequiredTransaction = false;
  state.declineSignatureRequiredTransactionId = -1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONMESSAGE', function SOCKET_ONMESSAGE(state, message) {
  state.message = message;
  var id = message.id,
      _message$result = message.result,
      result = _message$result === undefined ? {} : _message$result,
      error = message.error;

  if (error) {
    state.isTerminalAvailableAfterRequest = false;
  }
  if (id && state.requestTypes[id]) {
    switch (state.requestTypes[id]) {
      case __WEBPACK_IMPORTED_MODULE_2__mutation_types__["L" /* WS_GET_TERMINAL_DETAILS */]:
        state.availableTerminals = result;
        state.isTerminalAvailable = true;
        if (result.length === 0) {
          state.isTerminalAvailableAfterRequest = false;
        }
        delete state.requestTypes[id];
        break;

      case __WEBPACK_IMPORTED_MODULE_2__mutation_types__["M" /* WS_PS_SALE */]:
        state.PSSaleRequested = true;
        state.PSSaleRequestResponse = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, result, { id: id });

        if (result.transactionResult === 'SUCCESSFUL') {
          state.PSSaleRequestStatus = true;
        } else {
          state.PSSaleRequestStatus = false;
          console.log(message);
        }

        delete state.requestTypes[id];
        state.terminalNotificationStatus = result.transactionResult || 'TIMED_OUT';
        break;

      case __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* EODREPORTS_REQUEST */]:
        state.eodReports = result.transactionResult ? result : message;
        break;

      default:
        break;
    }
  } else if (message.method === 'terminalNotification') {
    state.PSSaleRequested = true;
    state.terminalNotificationStatus = message.params.notificationValue;
  } else if (message.method === 'signatureVerificationRequest') {
    state.declineSignatureRequiredTransaction = true;
    state.declineSignatureRequiredTransactionId = message.id;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_RECONNECT', function SOCKET_RECONNECT(state, count) {
  state.socket.isConnected = false;
  state.socket.connectionError = false;

  console.info(state, count);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_RECONNECT_ERROR', function SOCKET_RECONNECT_ERROR(state) {
  window.location.reload();
  state.socket.connectionError = true;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.91953ff61dd9fa7b3534.js